// English content for all 26 pages.
// Each entry contains: title, metaDescription, h1, kicker, intro, sections[]
// section: { heading, body (string|array of paragraphs), bullets[], list[{heading,body}] }

const EN = {
  home: {
    title: "ABS Solutions — Expert Accounting, Tax & SMSF Services in Melbourne",
    metaDescription:
      "Melbourne family-owned accounting firm offering tax returns, bookkeeping, SMSF, BAS/GST and business advisory to Australian individuals & businesses since 2013.",
    h1: "Maximise your business potential.",
    kicker: "ABS Solutions",
    intro:
      "Tailored accounting, taxation and advisory for individuals and businesses across Australia — built on twelve years of trust.",
    cards: [
      {
        kicker: "Trusted by businesses",
        heading: "Twelve years guiding Australian businesses.",
        body:
          "Absolute Business Services (ABS) is a family-owned practice providing accounting, bookkeeping, taxation and SMSF advisory. Clients rely on us to manage their tax and finances with precision and care.",
      },
      {
        kicker: "Expert team",
        heading: "Certified accountants and tax professionals.",
        body:
          "Our team brings CPA, registered tax-agent and SMSF specialist credentials together with hands-on experience across retail, manufacturing, technology and property.",
      },
      {
        kicker: "Customisable services",
        heading: "Personalised plans, one accounting team.",
        body:
          "Company and individual tax returns, BAS, bookkeeping, ABN/ACN/GST setup, SMSF management and audit — all delivered as a coherent, customised package.",
      },
    ],
    insightsHeading: "Sharp takes on what's next.",
    insightsIds: ["negative-gearing", "smsf", "family-trust", "home-office-tax", "small-business-tax", "tax-deadlines"],
    videosKicker: "Watch & learn",
    videosTitle: "Tax made simple — straight from our team.",
    videosIntro: "Videos from the ABS Solutions team on how to grow your business, stay compliant and get more out of tax season.",
    videos: [
      {
        id: "g1IdMn9u7aY",
        thumb: "/images/videos/g1IdMn9u7aY.jpg",
        caption: "ABS Solutions",
        ctaLabel: "Watch on YouTube",
      },
      {
        id: "sLvnEF9H11g",
        thumb: "/images/videos/sLvnEF9H11g.jpg",
        caption: "ABS Solutions",
        ctaLabel: "Watch on YouTube",
      },
      {
        id: "qNUJdsLB4s4",
        thumb: "/images/videos/qNUJdsLB4s4.jpg",
        caption: "ABS Solutions",
        ctaLabel: "Watch on YouTube",
      },
    ],
    reviewsHeading: "12+ Years\nTrusted by Australian Businesses",
    reviews: [
      {
        name: "Chun-Yi Chiu",
        color: "#1A73E8",
        text: "Louie and his team were able to help me with my Tax and Finance. I never thought I'd be able to get my own home, but ABS Solutions made this possible. If you need an accounting firm that understands Tax and Finance you should speak to ABS Solutions. Thank you Team.",
      },
      {
        name: "Jessie Chen",
        color: "#E91E63",
        text: "I was referred to ABS Solutions by a friend as I was not very satisfied with my previous accountant. I first spoke with Louie, who was very helpful in explaining how ABS works and introduced me to Kenny for my tax return this year. Kenny was great to work with — he always replied quickly and answered all my questions clearly. He didn't just lodge my tax return, but also helped me understand how to optimise my tax and plan better going forward. This is exactly what a good accountant should do. Really appreciate their help and I highly recommend ABS Solutions, especially Kenny. Thank you both Louie and Kenny!",
      },
      {
        name: "Christina Li",
        color: "#34A853",
        text: "My partner and I had a great experience with ABS Solutions and will definitely be using them long term for our financial needs. They helped us with our taxes and finances and were extremely responsive and communicative the entire way through. Special thank you to Louie who would answer all of my questions with so much knowledge and patience — we really appreciate your expertise!",
      },
      {
        name: "Danial",
        color: "#FBBC04",
        text: "ABS Solutions has been incredible in helping us with our property structuring and sorting out our finance. They took the time to understand our goals and explained complex structures in a way that was easy to follow. Their advice was strategic, practical, and tailored to our situation, ensuring our investments were set up in the most effective way. They also worked closely with us to streamline our finances, making the whole process smooth and stress-free. Professional, knowledgeable, and truly client-focused — I couldn't recommend ABS Solutions more highly.",
      },
      {
        name: "Leona Luo",
        color: "#9C27B0",
        text: "As a restaurant owner, I've found ABS Solutions incredibly reliable and knowledgeable. Louie, Kenny and Andy and their team understand the hospitality industry and always provide practical tax and business advice. They're efficient, responsive, and make managing our finances stress-free. Highly recommended!",
      },
      {
        name: "Teng",
        color: "#FF7043",
        text: "Honestly, ABS Solutions was a lifesaver! As a uni student working part-time, I had no clue what I was doing with my tax return. They were super friendly and explained everything in a way that actually made sense. The whole process was quick and easy, and I felt way more confident about my finances after. Highly recommend to any students who just want to get their tax sorted without the stress!",
      },
    ],
  },

  about: {
    title: "About Us — ABS Solutions",
    metaDescription:
      "Meet the ABS Solutions team — CPA-registered accountants, TPB tax agents and SMSF specialists serving Australian businesses, families and SMSF trustees since 2013.",
    h1: "A family-owned firm built on trust.",
    intro:
      "Absolute Business Solutions (ABS) has been guiding Australian businesses through tax, accounting and compliance for over 12 years.",
    sections: [
      {
        heading: "Trusted by businesses",
        body: [
          "We provide accounting, bookkeeping, taxation and SMSF advisory to small, medium and family enterprises. Our clients rely on us to manage their finances efficiently and ethically.",
          "Over the years we have built a reputation of excellence in the Australian accounting industry.",
        ],
      },
      {
        heading: "An expert team",
        body:
          "Our practice is led by Certified Public Accountants, registered tax professionals and bookkeeping specialists. Together we deliver advisory that combines technical depth with practical commercial sense.",
      },
      {
        heading: "Customisable services",
        body:
          "Every business is different. We work closely with our clients to understand their needs and deliver personalised solutions — company and individual tax returns, BAS, bookkeeping, ABN/ACN/GST setup, SMSF and business advisory.",
      },
    ],
    teamHeading: "Meet our professional team",
    teamGroupPhoto: "/images/staff/team-group.jpg",
    team: [
      {
        name: "Graham Yuan",
        role: "Managing Director",
        photo: "/images/staff/graham-yuan.jpg",
        bio:
          "Graham Yuan is the Managing Director of ABS Solutions and a Fellow of the Institute of Public Accountants (FIPA), with over 20 years of experience in accounting, taxation, and business advisory. As a qualified SMSF advisor and auditor, Graham provides expert guidance on superannuation, compliance, and tax-efficient wealth strategies for individuals, families, and businesses. With a deep understanding of complex regulatory environments and a client-focused approach, Graham delivers practical, tailored solutions that help clients grow and protect their financial future. His areas of expertise include tax planning, business structuring, compliance management, and self-managed super funds. Outside of the office, Graham enjoys going on boat cruises with his lovely wife — a hobby that reflects his appreciation for both relaxation and exploration.",
      },
      {
        name: "Louie Yuan",
        role: "Business Development Manager | Partner",
        photo: "/images/staff/louie-yuan.jpg",
        bio:
          "Louie Yuan is a dynamic entrepreneur who co-founded ABS Solutions with his father, Graham. The family-owned business has become renowned in accounting, taxation, finance, self-managed super funds, and consulting. His vision for ABS Solutions was to provide a one-stop shop for comprehensive business services. The family aspect is crucial to ABS Solutions' identity. Louie's wife, Kary, brings her expertise in finance and administration, enhancing the company's operations. Together, the Yuan family has built ABS Solutions into a trusted partner for businesses seeking reliable and forward-thinking solutions in accounting, taxation, finance, and business consulting.",
      },
      {
        name: "Andy Li",
        role: "Senior Tax Agent | Partner",
        photo: "/images/staff/andy-li.jpg",
        bio:
          "Andy Li is a Senior Tax Agent at ABS Solutions and a Certified Practising Accountant (CPA) with deep expertise in taxation, accounting, and financial advisory. He brings specialised knowledge in both the manufacturing and building industries, allowing him to deliver practical, industry-tailored solutions to clients navigating complex tax and compliance environments. With hands-on experience in cost management, project-based accounting, inventory control, and capital investment planning, Andy supports businesses in streamlining operations and improving financial outcomes. Outside of his professional role, Andy enjoys exploring artificial intelligence and coding, supported by his lovely wife, a daughter, and a son.",
      },
      {
        name: "Kenny Wong",
        role: "Senior Tax Agent | Partner",
        photo: "/images/staff/kenny-wong.jpg",
        bio:
          "Kenny Wong is a Senior Tax Agent at ABS Solutions and a Certified Practising Accountant (CPA) with over 10 years of experience in taxation, accounting, and business advisory. He specialises in supporting small to medium enterprises with practical, personalised tax strategies that ensure compliance and drive financial growth. Kenny is known for his strategic thinking, attention to detail, and commitment to delivering timely, value-driven advice. His deep understanding of Australian tax legislation, combined with a client-first mindset, makes him a trusted advisor to a wide range of businesses. Outside of work, Kenny enjoys camping and exploring the outdoors, supported by his lovely wife and their two young boys.",
      },
      {
        name: "Lexi Yang",
        role: "Associate Accountant",
        photo: "/images/staff/lexi-yang.jpg",
        bio:
          "Lexi supports clients across a range of industries, with a strong focus on cash flow visibility, accounting accuracy, and practical taxation support. Holding a Master of Professional Accounting from RMIT and a Securities Practitioner Qualification Certificate in China, she covers core accounting operations, financial reporting, and compliance — helping clients maintain financial clarity and operational control. She also assists with audit engagements, including external and internal audit preparation, documentation, and compliance requirements, delivering commercially grounded solutions tailored to each client's needs.",
      },
    ],
  },

  "services-pricing": {
    title: "Services & Pricing — ABS Solutions",
    metaDescription:
      "Transparent fixed-fee pricing for accounting, bookkeeping, BAS/GST, individual & company tax returns, SMSF setup & audit, business setup and audit services — GST inclusive.",
    h1: "Price list.",
    intro: "Transparent, all-inclusive pricing for businesses and individuals. All prices include GST.",
    categories: [
      {
        heading: "Business services",
        items: [
          { name: "Consultation — capped 1 hour", price: "$220", desc: "Business set-up, budgeting & modelling, taxation strategy & minimisation, loan structuring, bookkeeping, accounting software training (QuickBooks, MYOB, Xero)." },
          { name: "Business entity set-up — Sole trader", price: "$550", desc: "Business name, ABN, GST and TFN registration." },
          { name: "Business entity set-up — Trust, Partnership, Company", price: "$1,500", desc: "Includes business name, ABN, ACN, GST, trust deed and TFN registration." },
          { name: "Business entity set-up — SMSF package", price: "$6,600", desc: "SMSF trust name, ABN, ACN, GST, TFN, corporate trustee, SMSF trust deed, Bare/Custodian trust deed and 2-hour consultation." },
          { name: "Remote financial controller / CFO (per month, 1.5 hrs)", price: "$330", desc: "Remote financial management, advisory on accounting system improvements, in-house decision oversight." },
          { name: "Business plan", price: "$2,200", desc: "Strategy and implementation planning for new business owners and entrepreneurs." },
          { name: "Business plan and budget modelling", price: "$6,600", desc: "Full business plan plus financial modelling to assess profitability and support start-up lending." },
        ],
      },
      {
        heading: "Accounting services",
        items: [
          { name: "Bookkeeping — BAS (no activity)", price: "$110", desc: "Preparation and lodgement of quarterly BAS." },
          { name: "Bookkeeping — BAS", price: "From $275", desc: "Preparation and lodgement of quarterly BAS." },
          { name: "Bookkeeping — Payroll", price: "From $22", desc: "First employee $22; each additional employee $12." },
          { name: "Bookkeeping — Interim financials", price: "$1,100", desc: "Accountant-prepared management financials for the last 12 months." },
          { name: "STP end-of-year finalisation", price: "$220", desc: "Annual STP review, processing and lodgement to ATO." },
          { name: "Superannuation lodgement", price: "$220", desc: "Quarterly super lodgement to ATO and clearing house." },
          { name: "Annual WorkCover", price: "$220", desc: "Annual payroll summary preparation and WorkCover lodgement." },
          { name: "Forecasting (per update)", price: "From $1,100", desc: "Profit forecasting using current YTD data and your budget model." },
          { name: "Clearance certificate (CGT)", price: "$275", desc: "Prepare and submit a clearance certificate application for CGT property sales." },
          { name: "Foreign resident CGT withholding rate variation", price: "$495", desc: "Application to reduce the rate of foreign resident CGT withholding." },
        ],
      },
      {
        heading: "Taxation services",
        items: [
          { name: "Tax return — No PAYG / Student", price: "$100", desc: "For student card holders and non-trading entities." },
          { name: "Tax return — Individual PAYG simple", price: "$200", desc: "Group payment summary only, no other investments." },
          {
            name: "Tax return - Individual PAYG Add On",
            isAddOnCard: true,
            addOns: [
              { name: "Rental Property", price: "$165", desc: "Each property" },
              { name: "Shares and other income calculations hourly rate", price: "$110", desc: "" },
            ],
          },
          { name: "Property depreciation report", price: "$700", desc: "ATO-compliant depreciation reports to maximise deductions." },
          { name: "Tax return — Sole trader simple", price: "From $660", desc: "Preparation and lodgement for sole-trader businesses." },
          { name: "Tax return — Trusts, Companies, Partnerships", price: "$2,200", desc: "Preparation and lodgement for discretionary/unit trusts, companies and partnerships." },
          { name: "Tax return — SMSF", price: "$2,200", desc: "Preparation and lodgement for complex SMSF entities." },
        ],
      },
      {
        heading: "Auditing services",
        items: [
          { name: "Conveyancers trust account", price: "From $660", desc: "Audits compliant with the Conveyancers Act 2006 — protecting client funds and avoiding penalties." },
          { name: "Real estate agents trust account", price: "From $880", desc: "Audits compliant with the Estate Agents Act 1980 — accurate records and statutory compliance." },
          { name: "SMSF audit", price: "From $1,100", desc: "Independent ATO-compliant SMSF audits." },
          { name: "Not-for-profit organisations", price: "From $2,200", desc: "Transparent, accountable audits for NFP entities." },
        ],
      },
    ],
  },

  contact: {
    title: "Contact Us — ABS Solutions",
    metaDescription: "Contact ABS Solutions — Canterbury Melbourne head office and Brisbane CBD Eagle Street office. Call, email or book a free 15-minute consultation today.",
    h1: "Let's start the conversation.",
    intro: "Reach our team by phone, email or visit one of our offices in person.",
    offices: [
      {
        name: "Canterbury Office (Head Office)",
        company: "Absolute Business Services (ABS) Solutions",
        address: "205 Canterbury Road, Canterbury Victoria 3126, Australia",
        landline: "+61 3 9826 1316",
        mobile: "+61 430 032 721",
        email: "info@abs-solutions.com.au",
        mapQuery: "205 Canterbury Road, Canterbury VIC 3126, Australia",
      },
      {
        name: "Brisbane Office",
        company: "Absolute Business Services (ABS) Solutions",
        address: "Level 19, 10 Eagle Street, Brisbane City QLD, Australia",
        extra: "Brisbane office opening hours: By appointment only",
        landline: "+61 7 3087 3404",
        mobile: "+61 430 032 721",
        email: "info@abs-solutions.com.au",
        mapQuery: "10 Eagle Street, Brisbane City QLD, Australia",
      },
    ],
    hours: [
      ["Monday", "10:00 am – 05:00 pm"],
      ["Tuesday", "10:00 am – 05:00 pm"],
      ["Wednesday", "10:00 am – 05:00 pm"],
      ["Thursday", "10:00 am – 05:00 pm"],
      ["Friday", "10:00 am – 05:00 pm"],
      ["Saturday", "By Appointment"],
      ["Sunday", "By Appointment"],
    ],
  },

  // ---------- Service detail pages (template-driven) ----------

  "melbourne-accounting-firm": {
  title: "Melbourne Accountant | Melbourne Accounting Firm — ABS Solutions",
  metaDescription:
    "ABS Solutions is a Melbourne accountant and accounting firm based in Canterbury, led by CPA-registered partners offering tax, compliance and advisory services since 2012.",
  h1: "A Melbourne accountant you can build a long-term relationship with.",
  intro:
    "If you're a business owner, investor or family in Melbourne searching for an accountant who understands Victoria's rules — not just Australia's national ones — that's the gap ABS Solutions is built to fill. We've operated from our Canterbury HQ at 205 Canterbury Road since 2012, and our partners are CPA Australia members and registered Tax Practitioners Board agents working with clients across Melbourne's inner east and beyond.",
  sections: [
    {
      heading: "Full-spectrum accounting and tax services",
      body:
        "From precision audits to complex tax strategy, our services span the full business life-cycle. Whether you're a start-up filing your first return, or an established enterprise seeking growth, we partner with you every step of the way.",
      bullets: [
        "Compliance audits — annual financial audits, BAS / GST lodgement, statutory checks",
        "Tax optimisation — corporate & personal tax planning, cross-border solutions, dispute resolution",
        "Business support — ABN / ACN registration, payroll design, SMSF management",
        "Strategic advisory — entity restructure, cash-flow optimisation, exit-strategy planning",
      ],
    },
    {
      heading: "Melbourne and Victorian tax knowledge that matters",
      body:
        "Victoria runs its own thresholds and rates, and getting them wrong — or applying a NSW or Queensland rule of thumb by mistake — can mean overpaying or facing an unwelcome reassessment down the track. Victorian land tax applies above $300,000 for individuals and companies (just $25,000 for trusts), with a 4% absentee owner surcharge on top. Payroll tax doesn't kick in until your annual Victorian wages pass $1 million, then applies at 4.85% (a concessional 1.2125% for eligible regional employers), with additional surcharges once wages pass $10 million. Our team tracks these thresholds every year so your business isn't caught out.",
    },
    {
      heading: "A Melbourne team you can trust",
      body:
        "Our practice is built on CPA Australia members, registered Tax Practitioners Board agents and licensed SMSF specialists. We bring proven industry experience across retail, manufacturing and technology to deliver precise, sector-aware solutions. You can meet our team face-to-face at our Canterbury office — a short drive from Camberwell, Surrey Hills, Balwyn, Box Hill and the rest of Melbourne's inner east — or handle everything remotely online, your choice.",
    },
  ],
},

  "brisbane-accounting-firm": {
    title: "Brisbane Accounting Firm — ABS Solutions",
    metaDescription:
      "ABS Solutions Brisbane — CPA-led tax, SMSF, BAS/GST and business advisory for Queensland businesses, families and SMSF trustees, with over a decade of national experience.",
    h1: "A leading Brisbane accounting firm.",
    intro:
      "ABS Solutions partners with Queensland businesses, families and SMSF trustees — combining over a decade of national expertise with full-cycle accounting, tax and consulting services. If you're running a business in Brisbane and searching for an accounting firm that actually understands Queensland's rules rather than just Australia's national ones, that's the gap ABS Solutions is built to fill from our CBD office at Level 19, 10 Eagle Street. Queensland runs a genuinely different set of thresholds to the southern states: land tax kicks in at $600,000 for individuals and $350,000 for companies and trusts, with an extra 3% surcharge layered on top for foreign or absentee owners, while payroll tax doesn't apply until your annual Queensland wages pass $1.3 million, then sits at 4.75% up to $6.5 million and 4.95% above that, with a mental health levy kicking in past $10 million. Get these numbers wrong, or apply a Victorian or NSW rule of thumb by mistake, and you can end up either overpaying or facing an unwelcome reassessment down the track. Our team holds CPA Australia membership and works across individual tax returns, small business and company accounts, GST and BAS lodgement, family trust structuring and SMSF administration, for clients from the CBD out through Brisbane's inner and southern suburbs. Whether you need someone to walk you through this year's return or take over your bookkeeping and compliance for good, we'd rather build a relationship that outlasts a single tax season.",
    sections: [
      {
        heading: "Full-spectrum accounting and tax services",
        body:
          "From precision audits to complex tax strategy, our services span the full business life-cycle. Whether you're a Queensland start-up filing your first return, or an established enterprise seeking growth, we partner with you every step of the way.",
        bullets: [
          "Compliance audits — annual financial audits, BAS / GST lodgement, statutory checks",
          "Tax optimisation — corporate & personal tax planning, cross-border solutions, dispute resolution",
          "Business support — ABN / ACN registration, payroll design, SMSF management",
          "Strategic advisory — entity restructure, cash-flow optimisation, exit-strategy planning",
        ],
      },
      {
        heading: "A Brisbane team you can trust",
        body:
          "Our practice is built on CPA Australia members, registered Tax Practitioners Board agents and licensed SMSF specialists. We bring proven industry experience across retail, manufacturing and technology to deliver precise, sector-aware solutions.",
      },
      {
        heading: "Why Queensland businesses choose ABS Solutions",
        bullets: [
          "Family-owned boutique firm with over a decade of Australia-wide experience",
          "CPA Australia members, registered Tax Practitioners Board agents and licensed SMSF auditors on the team",
          "Bilingual English / Mandarin advisory for Queensland's growing Chinese-business community",
          "End-to-end services — accounting, BAS / GST, SMSF, audit, business setup and strategic advisory",
          "Transparent, GST-inclusive pricing with no hidden fees",
        ],
      },
      {
        heading: "Our core services for Brisbane clients",
        list: [
          { heading: "Tax & BAS / GST compliance", body: "Company, trust, partnership and individual tax returns. Quarterly BAS, GST registration and PAYG management — fully lodged with the ATO on your behalf." },
          { heading: "Bookkeeping & payroll", body: "Xero, MYOB and QuickBooks bookkeeping, payroll, Single Touch Payroll (STP), superannuation and WorkCover — set up and maintained by our specialists." },
          { heading: "SMSF setup & audit", body: "Self-managed super fund establishment, trustee structures, annual SMSF compliance and independent SMSF audit." },
          { heading: "Business setup & advisory", body: "Sole trader, company, partnership and trust setup. Business plans, financial modelling, cash-flow forecasts and outsourced CFO support." },
          { heading: "Audit & assurance", body: "Real-estate trust account audits, conveyancer audits and not-for-profit / association audits — performed under Australian Auditing Standards." },
        ],
      },
      {
        heading: "How we work with you in Brisbane",
        list: [
          { heading: "1. Consultation", body: "We meet on-site or by secure video to understand your business, financials and goals." },
          { heading: "2. Tailored proposal", body: "We propose a service plan and transparent fixed-fee quote suited to your size and complexity." },
          { heading: "3. Implementation", body: "Our partners and senior accountants handle tax, BAS, bookkeeping, SMSF or audit — you stay focused on running the business." },
          { heading: "4. Ongoing partnership", body: "Year-round access for advice as legislation, ATO rulings and your business circumstances evolve." },
        ],
      },
    ],
  },

  "canterbury-accounting": {
    title: "Bookkeeping & Accounting in Canterbury — ABS Solutions",
    metaDescription:
      "Boutique Canterbury Melbourne accountants delivering personal & business tax returns, BAS/GST, bookkeeping, SMSF set-up and audit services for over a decade.",
    h1: "Bookkeeping & accounting services in Canterbury.",
    intro:
      "Tailored accounting in the heart of Canterbury. Whether you run a small business or need full compliance support, our local team is ready to help. Our office sits right on Canterbury Road, in the Boroondara area of Melbourne's east, which means if you run a business anywhere from Camberwell and Surrey Hills through to Balwyn and Box Hill, you can walk in for a face-to-face conversation rather than dealing with a call centre or a generic online portal. Bookkeeping is where a lot of small business owners get into trouble without realising it: reconciling accounts, staying on top of Single Touch Payroll reporting to the ATO each pay run, keeping GST coded correctly in Xero or MYOB, and making sure your BAS lodgements line up with what your tax return eventually shows. We work as your registered BAS agent, which means we can lodge activity statements on your behalf and deal directly with the ATO if something needs sorting out, and we set most clients up on cloud accounting software so you can see your numbers in real time rather than waiting for a quarterly catch-up. Whether you need someone to take bookkeeping off your plate entirely, or just want a local accountant to check your books are clean before tax time, our Canterbury team handles both the week-to-week admin and the compliance side under one roof.",
    sections: [
      {
        heading: "Why choose ABS Solutions in Canterbury",
        bullets: [
          "Family-owned boutique firm with over 11 years' experience",
          "Certified accountants, tax professionals and bookkeeping specialists",
          "Customisable solutions — bookkeeping, BAS / GST, tax returns, SMSF, audit",
          "Our Canterbury office at 205 Canterbury Road for convenient face-to-face service",
        ],
      },
      {
        heading: "Our core services in Canterbury",
        list: [
          { heading: "Bookkeeping & BAS / GST compliance", body: "Day-to-day bookkeeping, ledger maintenance, reconciliations and BAS / GST lodgement — keeping your records accurate with minimal effort from you." },
          { heading: "Tax returns & Business Activity Statements", body: "Company and individual tax returns prepared and lodged, BAS managed, full compliance assured." },
          { heading: "SMSF advisory", body: "Expert guidance and management to keep your fund compliant and optimise performance." },
          { heading: "Audit & compliance", body: "Audit services designed to give you confidence in your financial reporting." },
          { heading: "Bespoke advisory & family office", body: "Personalised financial advisory and family-office level support — tailored to you." },
        ],
      },
      {
        heading: "How we work with you",
        list: [
          { heading: "1. Consultation", body: "We discuss your business needs, financial setup and goals." },
          { heading: "2. Custom plan", body: "We propose a bookkeeping / accounting plan suited to your size." },
          { heading: "3. Implementation", body: "We take care of your bookkeeping, BAS, tax, SMSF or audit while you focus on growth." },
          { heading: "4. Ongoing support", body: "We stay available for compliance updates and financial advice as your business evolves." },
        ],
      },
    ],
  },

  "chinese-accountants-aus": {
    title: "Chinese-speaking Accountants in Australia — ABS Solutions",
    metaDescription:
      "Bilingual English/Mandarin accounting firm serving Chinese-speaking individuals and businesses across Australia — tax, SMSF, BAS/GST and cross-border advisory.",
    h1: "Bilingual accountants serving Chinese communities across Australia.",
    intro:
      "We help Chinese-speaking clients navigate the Australian tax and compliance landscape with clarity, in their preferred language.",
    sections: [
      {
        heading: "Services we offer",
        bullets: [
          "Individual and company tax returns",
          "Business setup — ABN, ACN, GST, TFN",
          "Bookkeeping and BAS / GST lodgement",
          "SMSF setup, administration and audit",
          "Cross-border tax planning",
          "Family trust structures and estate planning",
        ],
      },
      {
        heading: "Why clients choose us",
        body:
          "Our partners and senior staff bring deep knowledge of Australian tax law combined with native-level Mandarin / Cantonese fluency. We translate complex regulation into clear, actionable advice.",
      },
    ],
  },

  "melbourne-accounting-tax": {
    title: "Melbourne Accounting & Tax Services — ABS Solutions",
    metaDescription:
      "Full-service Melbourne accountants for personal & company tax, BAS/GST, bookkeeping, SMSF and audit — CPA-registered and TPB-licensed family-owned firm since 2013.",
    h1: "Accounting & tax services for Melbourne businesses.",
    intro:
      "Our Melbourne team delivers end-to-end accounting and tax support — keeping you compliant, efficient and informed.",
    sections: [
      {
        heading: "Where we add value",
        bullets: [
          "Annual financial statements and tax returns",
          "Quarterly BAS and monthly payroll lodgement",
          "Year-round tax planning, not just at lodgement time",
          "Business performance reviews and benchmarking",
          "Industry-specific deduction analysis",
        ],
      },
      {
        heading: "Working with us",
        body:
          "From the first consultation onwards, you'll be matched with a dedicated accountant who understands your business, your goals and your sector — backed by the full ABS Solutions team.",
      },
    ],
  },

  "individual-tax": {
    title: "Individual Tax Services — ABS Solutions",
    metaDescription:
      "Personal tax return preparation and tax planning by TPB-registered Tax Agents — PAYG, deductions, rental property, shares and cross-border income. Maximise your refund.",
    h1: "Individual tax services.",
    intro:
      "Whether you live in Australia or abroad, our registered tax agents handle your personal tax return with precision and care.",
    sections: [
      {
        heading: "What we do",
        list: [
          { heading: "Personal income tax preparation", body: "Our registered tax agents and accountants prepare and lodge your return accurately and in line with ATO requirements." },
          { heading: "Maximise your refund", body: "We legitimately identify and apply all the deductions and offsets available to your circumstances." },
          { heading: "Personalised advice", body: "Every client is different — we give tailored tax advice so you make smarter financial decisions." },
          { heading: "An effortless process", body: "Send us your tax documents and our team takes care of the rest. Transparent, simple, paperless." },
        ],
      },
      {
        heading: "Why ABS Solutions",
        body:
          "Before we begin, we send you a clear document checklist so you know exactly what to prepare. Throughout the process our tax advisors are on hand to explain rules and help you stay compliant.",
      },
    ],
  },

  "melbourne-company-personal-tax": {
    title: "Melbourne Company & Personal Tax — ABS Solutions",
    metaDescription:
      "End-to-end Melbourne company & personal tax services — annual returns, planning, deductions review, payroll tax and tax-effective wealth & succession strategies.",
    h1: "Melbourne company & personal tax.",
    intro:
      "ABS Solutions provides Melbourne businesses and individuals with comprehensive, one-stop tax services — local knowledge, strategic outcomes.",
    sections: [
      {
        heading: "Our tax services include",
        list: [
          { heading: "Individual tax returns", body: "Salary and wages, sole-trader profits, rental income and dividends — fully claimed with every eligible deduction and offset." },
          { heading: "Company tax returns", body: "Compliant financial preparation, taxable-income calculation and company tax lodgement to keep your business on the right side of the law." },
          { heading: "Sole trader & partnership returns", body: "We handle the bookkeeping, claim the deductible expenses and lodge your return on time." },
          { heading: "Employer compliance", body: "STP reporting, PAYG withholding, superannuation guarantee, BAS and IAS lodgement — all taken care of." },
          { heading: "Investment property tax advice", body: "Rental income reporting, depreciation schedules, interest deductions and CGT planning to maximise your investment outcome." },
          { heading: "Tax planning & advisory", body: "Multi-source income? We integrate all streams and build a long-term plan for sustained tax efficiency." },
        ],
      },
    ],
  },

  "company-tax": {
    title: "Professional Company Tax Services — ABS Solutions",
    metaDescription:
      "Specialist company tax returns and corporate tax planning by CPA-registered accountants — Division 7A, FBT, R&D incentives, instant asset write-off and quarterly PAYG.",
    h1: "Professional company tax services.",
    intro:
      "Tax decisions ripple through every part of your company. Our specialists keep you compliant, optimise your structure and lift your financial efficiency.",
    sections: [
      {
        heading: "How we work",
        body:
          "Our tax advisors keep close to your business — understanding operations and finances so the strategy fits. We track every ATO update and align our process with the latest systems and legislation.",
        bullets: [
          "Annual company income tax return and financials",
          "Strategic tax planning and advice",
          "Deduction reviews and concession analysis",
          "Compliance reviews and optimisation",
          "Restructuring and corporate advisory",
        ],
      },
      {
        heading: "Ongoing compliance & support",
        body:
          "Australian tax law evolves constantly. Our team helps you meet your obligations while keeping risk to a minimum — delivering transparent, strategic outcomes.",
      },
    ],
  },

  "small-business-tax": {
    title: "Small Business Tax in Australia — ABS Solutions",
    metaDescription:
      "Small-business tax services for Australian sole traders, partnerships and Pty Ltd companies — deductions, instant asset write-off, BAS and ATO lodgement support.",
    h1: "Small business tax in Australia.",
    intro:
      "If an expense was incurred to produce or grow your business income, it's usually deductible in the same financial year. We make sure you claim everything you're entitled to.",
    sections: [
      {
        heading: "What you can typically claim",
        bullets: [
          "Wages and superannuation",
          "Marketing and advertising",
          "Accounting and finance fees",
          "Office rent and operating costs",
          "Business insurance",
        ],
      },
      {
        heading: "What to keep in mind",
        body:
          "Private expenses are not deductible. If a cost is mixed, only the business portion can be claimed. Keep invoices, contracts and payment records — without these the ATO may disallow your deduction.",
      },
      {
        heading: "Travel expenses",
        body:
          "Business travel — flights, trains, taxis and accommodation — can be claimed when the trip's primary purpose is work. Reasonable meal costs while travelling overnight may also qualify.",
      },
      {
        heading: "Working from home",
        body:
          "If part of your home is dedicated to running your business you may claim a proportion of mortgage interest, rent, utilities, internet, cleaning and depreciation. Be aware that an exclusive business-use area can trigger CGT exposure on the sale of your home — plan ahead.",
      },
    ],
  },

  "business-tax": {
    title: "How Australian Businesses File Tax — ABS Solutions",
    metaDescription:
      "Specialist business tax compliance and planning — company, trust and partnership returns, FBT, PAYG instalments, instant asset write-off and ATO dispute support.",
    h1: "How Australian businesses file tax.",
    intro:
      "Every business — sole trader, partnership, company or trust — has a tax obligation to the ATO. Knowing what to lodge and when is essential.",
    sections: [
      {
        heading: "Key obligations",
        bullets: [
          "Annual income tax return",
          "Quarterly Business Activity Statements (BAS)",
          "Pay-As-You-Go (PAYG) withholding for employees",
          "Superannuation guarantee contributions",
          "Fringe Benefits Tax (FBT) where applicable",
        ],
      },
      {
        heading: "Common challenges",
        body:
          "Most businesses struggle with cash-flow timing of tax payments, classifying expenses, and balancing compliance with growth. We provide a single point of contact for all of it.",
      },
    ],
  },

  "tax-deadlines": {
    title: "Australian Tax Deadlines — ABS Solutions",
    metaDescription:
      "Key 2025–26 ATO tax deadlines for individuals, companies, trusts, partnerships and SMSFs — BAS, PAYG, super and annual return due dates explained in one place.",
    h1: "Australian tax deadlines.",
    intro:
      "Missing a lodgement deadline can trigger penalties and interest. Use the dates below as a guide and partner with us to never miss one.",
    sections: [
      {
        heading: "Individual returns",
        bullets: [
          "Self-lodged returns: 31 October each year",
          "Lodged through a registered tax agent: typically 15 May the following year (subject to client status)",
          "Outstanding prior returns may shorten future deadlines",
        ],
      },
      {
        heading: "Company / trust returns",
        bullets: [
          "Typically due 15 May after the income year",
          "Earlier deadlines apply to taxable large / medium taxpayers",
          "New entities: first-year deadlines vary — check with us",
        ],
      },
      {
        heading: "BAS lodgement",
        bullets: [
          "Monthly BAS: 21st of the following month",
          "Quarterly BAS: 28 Oct, 28 Feb, 28 Apr, 28 Jul",
          "Extensions available when lodging through a tax agent",
        ],
      },
    ],
  },

  "bas-lodgement": {
    title: "Australian BAS Lodgement — ABS Solutions",
    metaDescription:
      "Full Business Activity Statement (BAS) lodgement service for Australian businesses — GST, PAYG withholding, PAYG instalments and FBT, lodged on time by your tax agent.",
    h1: "Business Activity Statement (BAS) lodgement.",
    intro:
      "Many business owners and new entrepreneurs aren't fully across what BAS means and how it must be lodged. This guide walks you through the concept, the records you need to prepare, the lodgement methods available, the deadlines that apply and how to correct mistakes.",
    sections: [
      {
        heading: "What BAS covers",
        body:
          "The Business Activity Statement is how Australian businesses periodically report and pay tax obligations to the Australian Taxation Office (ATO). It consolidates several tax types into a single return:",
        bullets: [
          "Goods and Services Tax (GST)",
          "PAYG withholding for employees",
          "Fringe Benefits Tax (FBT) instalments",
          "Imported vehicle tax, Wine Equalisation Tax (WET), Luxury Car Tax (LCT) and other applicable taxes",
        ],
      },
      {
        heading: "What you must disclose for GST",
        body:
          "Within the GST section of your BAS, you'll need to declare the following figures for the period:",
        bullets: [
          "Total sales",
          "Export sales",
          "Zero-rated (GST-free) sales",
          "Capital purchases",
          "Non-capital purchases",
        ],
      },
      {
        heading: "Simplified BAS",
        body:
          "If your business has GST-taxable turnover under AUD 10 million, you can usually opt in to Simplified BAS — a streamlined version with fewer GST labels that reduces compliance work without changing your underlying GST obligations.",
      },
      {
        heading: "Records to prepare before lodgement",
        body:
          "Accurate, complete records make BAS lodgement faster and reduce the risk of audit findings. Before each period close, gather:",
        bullets: [
          "Sales invoices and revenue records",
          "Purchase invoices and expense records",
          "Bank statements for every business account",
          "Payroll records and PAYG withholding data",
          "Accounting software financials (P&L, balance sheet)",
        ],
      },
      {
        heading: "How to lodge your BAS",
        body:
          "Businesses can lodge BAS via several ATO-approved channels:",
        list: [
          { heading: "1. Online via ATO services or accounting software", body: "The most common method — direct lodgement through ATO Online Services for Business or via integrated software like Xero, MYOB and QuickBooks." },
          { heading: "2. Through a registered tax agent", body: "Lodging via a tax agent unlocks extended deadlines and adds a layer of professional review." },
          { heading: "3. Mailed paper form", body: "Still permitted for businesses without digital access — but slower and more error-prone." },
          { heading: "4. Phone (nil lodgements only)", body: "If you have nothing to report for the period, a nil BAS can be lodged by phone." },
        ],
      },
      {
        heading: "Lodgement frequency & deadlines",
        body:
          "Your lodgement cycle depends on your business size and the ATO's classification:",
        bullets: [
          "Monthly BAS — due on the 21st of the following month",
          "Quarterly BAS — due 28 Oct, 28 Feb, 28 Apr and 28 Jul each year",
          "Extensions are typically available when you lodge through a registered tax agent",
        ],
      },
      {
        heading: "Record retention & correcting mistakes",
        body:
          "By law you must keep all BAS-related records for at least five years. If you discover an error in a lodged BAS you have two options to correct it:",
        bullets: [
          "Make the adjustment in your next BAS (for small / in-period corrections)",
          "Submit a formal Revision through the ATO to fix the original lodgement",
        ],
      },
      {
        heading: "How ABS Solutions helps",
        body:
          "We prepare and lodge accurate BAS on your behalf, optimise your end-to-end tax workflow and minimise compliance risk. Engaging a professional team lets you focus on growing the business while a trusted specialist handles your BAS, GST and PAYG obligations.",
        bullets: [
          "Timely, accurate BAS lodgement every cycle",
          "GST and PAYG compliance under one roof",
          "Tax workflow optimisation and software integration",
          "Reduced exposure to ATO penalties and interest",
        ],
      },
    ],
  },

  "gst-registration": {
    title: "Australian GST Registration & Reporting — ABS Solutions",
    metaDescription:
      "GST registration, monthly or quarterly reporting and BAS lodgement for Australian sole traders, partnerships, companies and trusts — avoid ATO penalties and claim credits.",
    h1: "Australian GST registration & reporting.",
    intro:
      "Goods and Services Tax (GST) is a 10% broad-based consumption tax that applies to most goods, services and other items sold or consumed in Australia. We handle registration, on-time reporting and ongoing compliance — so you stay focused on the business.",
    sections: [
      {
        heading: "When you must register for GST",
        body: "Registration is mandatory when any of the following apply:",
        bullets: [
          "Annual GST turnover of $75,000 or more (or $150,000 for not-for-profit entities)",
          "Providing taxi, ride-share or limousine travel — regardless of turnover",
          "Wanting to claim fuel tax credits for your business",
          "Operating as a not-for-profit with eligible activities",
        ],
      },
      {
        heading: "Why voluntary registration may still be worthwhile",
        body:
          "Even below the threshold, voluntary registration can make sense if you incur significant GST on inputs (e.g. start-ups, capital-heavy businesses) or supply other GST-registered businesses who can claim back the GST you charge.",
      },
      {
        heading: "How to register",
        body: "GST registration is done via the Australian Business Register (ABR) and can be completed alongside your ABN application. You'll need:",
        bullets: [
          "An active ABN",
          "Your business legal name and trading name",
          "Estimated annual GST turnover",
          "Reporting cycle preference (monthly, quarterly, annual)",
          "Accounting method (cash vs accrual)",
        ],
      },
      {
        heading: "Our GST service",
        body: "Once registered, GST becomes part of your ongoing tax cycle. We deliver:",
        list: [
          { heading: "GST registration", body: "Complete registration with the ATO via ABR, including reporting-cycle advice." },
          { heading: "Quarterly or monthly BAS", body: "Preparation and lodgement of your BAS through ATO Online Services or via your accounting software." },
          { heading: "Input tax credit reviews", body: "Make sure you're claiming every legitimate credit and not paying more GST than required." },
          { heading: "Cross-border GST advisory", body: "Imports, exports, digital services and GST-free supplies — properly classified and reported." },
          { heading: "GST audit support", body: "Liaison with the ATO, preparation of evidence and managing the audit process end-to-end." },
        ],
      },
      {
        heading: "Common mistakes to avoid",
        body: "Many small businesses lose money on GST through simple errors. Watch for:",
        bullets: [
          "Failing to register once turnover crosses the threshold (penalties + back-payment apply)",
          "Charging GST on GST-free items (or vice versa)",
          "Missing input tax credits because invoices lack a valid ABN or GST detail",
          "Confusing tax invoices with regular invoices for purchases over $82.50",
          "Late BAS lodgement triggering Failure to Lodge (FTL) penalties",
        ],
      },
      {
        heading: "How ABS Solutions helps",
        body: "We take the headache out of GST — from initial registration to every quarterly cycle and the occasional ATO review:",
        bullets: [
          "GST + ABN registration in one engagement",
          "Quarterly / monthly BAS lodgement",
          "Input tax credit reviews and bookkeeping clean-up",
          "Cross-border GST advice for imports / exports",
          "Bilingual EN / ZH service throughout",
        ],
      },
    ],
  },

  tfn: {
    title: "Tax File Number (TFN) — ABS Solutions",
    metaDescription:
      "Tax File Number explained — who needs a TFN, how to apply, what records to keep, and the rules for Australian residents, non-residents, students and visa holders.",
    h1: "What is a TFN?",
    intro:
      "A Tax File Number (TFN) is your personal tax identifier issued by the Australian Taxation Office (ATO). It is essential for working, banking, investing and running a business in Australia. This guide walks you through what a TFN is, who needs one, how to apply and how to keep your records compliant.",
    sections: [
      {
        heading: "Why you need a TFN",
        body:
          "A TFN unlocks the standard Australian tax system. Without one, you may be taxed at the highest marginal rate on wages, bank interest and certain investment income. Common reasons you'll need a TFN include:",
        bullets: [
          "Legal employment — most employers require your TFN for payroll and PAYG withholding",
          "Banking and investing — without a TFN, financial institutions must withhold at the top rate",
          "Tax records — refunds, government benefits and income matching all depend on your TFN",
          "Government services — required to lodge a tax return and access many ATO online services",
        ],
      },
      {
        heading: "Who should apply",
        body:
          "Almost every working-age Australian resident, and many temporary visa holders, will benefit from a TFN. You should apply if you are:",
        bullets: [
          "A new resident, student, temporary visa holder or anyone with a work right",
          "Starting work, freelancing or starting a business",
          "Opening a bank, super or investment account",
          "Planning to operate via a sole trader, company, trust or partnership, or applying for an ABN",
        ],
      },
      {
        heading: "How to apply for a TFN",
        body:
          "There are several ways to apply for a TFN, depending on your residency status:",
        list: [
          { heading: "Australian residents", body: "Apply online via the ATO website or through myGov. You'll need proof of identity documents and a residential address. Most applications are processed within 28 days." },
          { heading: "Foreign passport holders", body: "Apply online through the ATO once you arrive in Australia and have a valid visa with work rights. You'll need your passport and visa details." },
          { heading: "Working holiday makers", body: "Apply online after arriving in Australia. Note that working-holiday-maker tax rates apply on income earned under the relevant visa." },
          { heading: "Children under 16 or those without standard ID", body: "A paper-based application may be required. ABS Solutions can guide you through the correct form and documentation." },
        ],
      },
      {
        heading: "Documents you'll need",
        body:
          "Preparation is the difference between a smooth application and weeks of delay. Before you apply, gather:",
        bullets: [
          "Government-issued photo ID (passport or driver's licence)",
          "Proof of Australian residential address",
          "Visa details (for non-residents)",
          "Date of arrival in Australia (for non-residents)",
          "Existing TFN if one was issued previously (you should never apply for a second TFN)",
        ],
      },
      {
        heading: "Keeping your TFN safe",
        body:
          "A TFN is sensitive personal information — treat it like a bank PIN. The ATO will never email or call to ask for your TFN. Only share it with your employer, registered tax agent, bank, super fund or government agency. If you suspect your TFN has been compromised, contact the ATO immediately.",
      },
      {
        heading: "How ABS Solutions helps",
        body:
          "Our registered tax agents make the TFN application process straightforward. We provide a clear document checklist before you start, explain residency and visa rules in plain English (or Mandarin / Cantonese), and stay on hand to help you lodge your first Australian tax return once your TFN is issued.",
        bullets: [
          "Document checklist and pre-application review",
          "Bilingual EN / ZH support throughout the process",
          "ATO liaison if your application stalls",
          "Follow-on tax planning and first-return lodgement",
        ],
      },
    ],
  },

  abn: {
    title: "How to Apply for an ABN in Australia — ABS Solutions",
    metaDescription:
      "Apply for an Australian Business Number (ABN) — eligibility criteria, ABR registration, GST/PAYG add-ons and what to do once your ABN is issued. Step-by-step guide.",
    h1: "Apply for an ABN in Australia.",
    intro:
      "Operating a business in Australia typically involves choosing the right structure, obtaining a TFN, and applying for an Australian Business Number (ABN). The ABN is your unique 11-digit identifier across the ATO and the wider business environment.",
    sections: [
      {
        heading: "What is an ABN and why you need one",
        body:
          "The ABN identifies your business to government and other organisations. You'll need one to register for GST, claim energy grants credits, deal with other businesses on invoices, withhold at the correct rate, and operate as a substantive entity. Without an ABN, payers may withhold tax at 47% from amounts owed to you.",
      },
      {
        heading: "How to apply for an ABN",
        body:
          "Eligible individuals and entities apply online through the Australian Business Register (ABR). Preparation makes the difference — gather the following before you start:",
        bullets: [
          "Applicant name and contact details",
          "Trading and postal addresses",
          "Business structure (sole trader, company, partnership, trust)",
          "A detailed description of business activity",
          "Information about associated parties (directors, partners, trustees)",
          "Proof of identity documents",
          "Date the business will start",
        ],
      },
      {
        heading: "Who can apply",
        body:
          "ABN entitlement is tested objectively — you must be genuinely carrying on (or commencing) an enterprise in Australia. You're typically eligible if you are:",
        bullets: [
          "Carrying on a business in Australia",
          "Running an enterprise (including a profession, trade, vocation or one-off commercial activity)",
          "Supplying goods or services in the Australian market",
          "A company registered under the Corporations Act in Australia",
        ],
      },
      {
        heading: "Common reasons applications are refused",
        body:
          "The ABR can refuse or revoke ABNs where the entitlement test isn't satisfied. Common pitfalls:",
        bullets: [
          "A hobby or one-off sale that isn't really an enterprise",
          "Missing or inconsistent identity information",
          "Operating before formal entity formation (e.g. company not yet registered)",
          "Applying primarily to dodge PAYG withholding while functionally being an employee",
        ],
      },
      {
        heading: "After registration — what comes next",
        body:
          "Once you have your ABN, ongoing obligations follow. ABS Solutions helps with all of them:",
        bullets: [
          "Lodge income tax returns (company or individual depending on structure)",
          "If GST-registered, lodge BAS quarterly or monthly",
          "Meet PAYG withholding and super guarantee obligations for employees",
          "Keep business records for at least five years",
          "Update the ABR within 28 days of any change to business details",
          "Cancel the ABN if you stop trading — leaving it active triggers unnecessary lodgements",
        ],
      },
      {
        heading: "How ABS Solutions helps",
        body:
          "We package ABN with the right business structure and registrations from day one — so the foundation is right and the ongoing compliance fits your operating model:",
        bullets: [
          "Structure advice (sole trader, partnership, company, trust)",
          "ABN, TFN, GST and PAYG registration in one engagement",
          "Trust deeds, company constitution and director ID guidance",
          "Bookkeeping and BAS set-up from the first transaction",
          "Bilingual EN / ZH service throughout",
        ],
      },
    ],
  },

  "company-setup": {
    title: "Company Setup & Business Plan Services — ABS Solutions",
    metaDescription:
      "End-to-end Pty Ltd company setup and business planning — ACN registration, ASIC compliance, ABN/GST, share structure, shareholder agreements and ongoing advisory.",
    h1: "Company structure & business plan services.",
    intro:
      "From entity registration to financial modelling, we help you build the right foundations for sustainable growth.",
    sections: [
      {
        heading: "What we deliver",
        list: [
          { heading: "Entity registration", body: "Sole trader, partnership, company, trust or SMSF — including ABN, ACN, GST and TFN registration." },
          { heading: "Trust deeds & constitutions", body: "Custom-drafted documents tailored to your operating model and asset protection needs." },
          { heading: "Business plans", body: "Strategy documents that articulate your value proposition, market positioning and execution plan." },
          { heading: "Budget & financial modelling", body: "Three-way financial models to test profitability, support lending applications and inform decision-making." },
          { heading: "Advisory", body: "Ongoing structural and tax advice as your business scales." },
        ],
      },
    ],
  },

  smsf: {
    title: "Self-Managed Super Fund (SMSF) Services — ABS Solutions",
    metaDescription:
      "Self-managed super fund (SMSF) setup, accounting, tax returns and independent audit — full ATO compliance support from CPA-registered SMSF specialists.",
    h1: "Self-Managed Super Fund (SMSF) services.",
    intro:
      "An SMSF gives you direct control over how your retirement savings are invested and managed. We handle the setup, ongoing accounting, tax and audit coordination — so you remain compliant while focusing on your long-term wealth strategy.",
    sections: [
      {
        heading: "Is an SMSF right for you?",
        body:
          "An SMSF is a private superannuation fund you run yourself, as trustee, for the benefit of up to six members. It is not for everyone — but for the right circumstances it offers control, investment flexibility and meaningful tax advantages.",
        bullets: [
          "You want direct control over your super investments",
          "Your combined super balance is large enough to justify the running costs",
          "You want to invest in assets like direct property, term deposits, listed shares or precious metals",
          "You have a long-term retirement plan and are ready to take on trustee responsibility",
        ],
      },
      {
        heading: "What an SMSF can invest in",
        body:
          "Provided your investment strategy permits it and the sole-purpose test is satisfied, an SMSF can hold a wide range of assets:",
        bullets: [
          "Australian and international listed shares",
          "Cash, term deposits and managed funds",
          "Direct residential and commercial property",
          "Precious metals (gold, silver, platinum) and collectibles (subject to strict rules)",
          "Limited-recourse borrowing arrangements (LRBAs) for property",
        ],
      },
      {
        heading: "Our SMSF services",
        body:
          "We deliver the full SMSF life-cycle — set-up, day-to-day administration, annual compliance and audit liaison — so you stay focused on strategy:",
        list: [
          { heading: "SMSF setup", body: "Trust structure, deed preparation, corporate trustee creation, ABN / TFN application, ATO registration and bank account setup." },
          { heading: "Accounting & tax", body: "Annual financial statements, member statements, SMSF tax return preparation, contribution and pension reporting." },
          { heading: "Audit coordination", body: "We prepare audit-ready files and liaise with an independent SMSF auditor on your behalf." },
          { heading: "Investment & tax strategy", body: "Pension-phase planning, contribution strategy, transition-to-retirement structuring and tax-efficient asset allocation." },
        ],
      },
      {
        heading: "Key tax advantages",
        body:
          "When run correctly, SMSFs deliver some of the most favourable tax treatment available in Australia:",
        bullets: [
          "Investment earnings taxed at the concessional 15% rate",
          "CGT discounted by one-third on assets held longer than 12 months (effective 10%)",
          "Tax-free earnings on the pension-phase portion of the fund (subject to transfer balance caps)",
          "Flexible estate planning and binding death-benefit nominations for the next generation",
        ],
      },
      {
        heading: "Compliance you must not ignore",
        body:
          "The ATO is the regulator of SMSFs and applies strict compliance requirements. Breaches can trigger administrative penalties or, in extreme cases, the fund being declared non-complying. Key obligations include:",
        bullets: [
          "Documented investment strategy reviewed annually",
          "Sole-purpose test — every action must benefit member retirement",
          "Arm's-length dealings with related parties (no personal use of fund assets)",
          "Annual independent audit and SMSF return lodgement",
          "Trustee education and signed trustee declarations",
        ],
      },
      {
        heading: "How ABS Solutions helps",
        body:
          "We act as your specialist SMSF accountant and adviser — translating compliance complexity into clear actions and giving you confidence that your fund is run correctly:",
        bullets: [
          "End-to-end SMSF set-up (including SMSF + corporate trustee + bare trust where required)",
          "Annual compliance, member statements and ATO lodgement",
          "Audit liaison with an independent ASIC-registered SMSF auditor",
          "Strategic advice on contributions, pensions and intergenerational planning",
        ],
      },
    ],
  },

  "family-trust": {
    title: "Australian Family Trust Guide — ABS Solutions",
    metaDescription:
      "Complete guide to Australian family (discretionary) trusts — setup, trustee duties, beneficiary rules, tax distributions, asset protection and ongoing ATO compliance.",
    h1: "Australian family trust — the complete guide.",
    intro:
      "Family trusts are a popular Australian structure for income distribution, asset protection and long-term tax planning. To deliver these benefits they must be set up and managed correctly — this guide walks you through how a family trust works, its common uses, the tax rules, the setup costs and the obligations that follow.",
    sections: [
      {
        heading: "What is a family trust?",
        body:
          "A family trust is a legal structure in which a trustee holds and manages assets for the benefit of a defined group of beneficiaries (typically a family). The arrangement is governed by a trust deed, which sets out who can be a beneficiary and how income and capital can be distributed. Most Australian family trusts are discretionary trusts — the trustee decides each year how income and capital are distributed among the eligible beneficiaries.",
      },
      {
        heading: "Common uses of a family trust",
        body:
          "Used correctly, a family trust is one of the most versatile structures in Australian tax and wealth planning:",
        list: [
          { heading: "Tax planning", body: "Distribute income across eligible beneficiaries on lower marginal rates — entirely within the bounds of Australian tax law." },
          { heading: "Asset protection", body: "Separate trust assets from personal assets to reduce exposure to litigation, business failure or creditor risk." },
          { heading: "Family wealth management", body: "Coordinate long-term wealth-building and intergenerational succession in a single structure." },
          { heading: "Investment & business structures", body: "Hold investment property, share portfolios or operate the family business under a single accountable umbrella." },
        ],
      },
      {
        heading: "Tax rules at a glance",
        body:
          "Understanding the trust tax framework is essential. A family trust generally does not pay income tax in its own right — instead, income is distributed to beneficiaries and taxed in their hands at their personal marginal rates. However, watch the following carefully:",
        bullets: [
          "Undistributed income is taxed at the top marginal rate (currently 45%)",
          "Distributions to minor beneficiaries face penalty tax rates above a low threshold",
          "Valid trustee resolutions must be made before 30 June each year",
          "Streaming of franked dividends and capital gains is permitted under specific rules",
          "A Family Trust Election (FTE) may be required to access certain tax concessions",
        ],
      },
      {
        heading: "Setup process",
        body:
          "A correctly structured family trust requires careful planning before the deed is signed. The standard set-up steps are:",
        list: [
          { heading: "1. Structural design", body: "Decide on individual or corporate trustee, beneficiary class, appointor structure and any related entities." },
          { heading: "2. Trust deed drafting", body: "Engage a legal practitioner to draft a deed tailored to your purpose and family circumstances." },
          { heading: "3. Trust execution", body: "Settlor pays the settlement sum, trustees sign, and the deed is dated and stamped where required." },
          { heading: "4. Tax registrations", body: "Apply for the trust's TFN, ABN and GST (if required) and register with state revenue offices for land tax." },
          { heading: "5. Bank & operating accounts", body: "Open trust bank accounts and update beneficiary records." },
        ],
      },
      {
        heading: "Typical setup costs",
        body:
          "A standard family trust setup typically ranges from A$1,200 to A$2,000 + GST and includes the trust deed, structural advice, beneficiary configuration, TFN and ABN registration, and related tax registrations. Adding a corporate trustee or bare trust (e.g. for SMSF LRBAs) is an additional cost.",
      },
      {
        heading: "Ongoing compliance obligations",
        body:
          "A family trust is a living structure that requires regular attention to remain effective and compliant:",
        bullets: [
          "Annual trustee resolutions before 30 June",
          "Annual financial statements and a trust tax return",
          "Beneficiary distribution statements (PAYG payment summaries equivalents)",
          "Family Trust Election review where applicable",
          "Land tax compliance for property-holding trusts (varies by state)",
        ],
      },
      {
        heading: "How ABS Solutions helps",
        body:
          "We provide end-to-end family-trust support — from structuring advice through to the annual lodgement cycle — combining technical depth with practical commercial insight:",
        bullets: [
          "Strategic structuring advice tailored to your circumstances",
          "Trust deed coordination with our legal partners",
          "Trust setup including ABN, TFN and GST registration",
          "Annual accounts, tax returns and trustee resolution drafting",
          "Bilingual EN / ZH advice and family-office level service",
        ],
      },
    ],
  },

  "negative-gearing": {
    title: "Australian Negative Gearing — A Complete Analysis | ABS Solutions",
    metaDescription:
      "How negative gearing works in Australia — rental losses, depreciation, capital gains and which investors benefit most. Worked examples and ATO rules in plain English.",
    h1: "Australian negative gearing — a complete analysis.",
    intro:
      "Negative gearing isn't a tax — it's a tax concept. It describes the position when an investment's deductible costs (interest, depreciation) exceed the income it generates, creating a paper loss that can offset other income.",
    sections: [
      {
        heading: "How negative gearing works",
        body:
          "When an investment property's rental income is less than its deductible costs (loan interest, council rates, repairs, depreciation, agent fees), the resulting loss is deductible against other assessable income — typically your salary or business profits. The benefit accrues most strongly to investors on higher marginal tax rates.",
      },
      {
        heading: "Why investors use it",
        body:
          "Negative gearing is a long-game strategy that combines tax efficiency with asset accumulation:",
        list: [
          { heading: "Lower tax", body: "Offsetting income from your day job with property losses reduces taxable income — most effective for higher marginal-rate taxpayers." },
          { heading: "Capital efficiency", body: "Use leverage to access a larger asset and compound growth without tying up all your cash." },
          { heading: "Long-term capital growth", body: "Property generally appreciates over time. Holding the asset isn't a taxable event — the capital gain is realised on sale, with the 50% CGT discount available for individuals holding more than 12 months." },
          { heading: "Wider investment universe", body: "You can target growth corridors rather than chasing yield, broadening your investment options." },
        ],
      },
      {
        heading: "How losses are generated",
        body:
          "Beyond cash costs (interest, council rates, insurance, property management, repairs), tax law lets you deduct non-cash items that can create a paper loss without any actual cash outflow:",
        bullets: [
          "Division 43 capital-works depreciation (the building shell, typically 2.5% pa)",
          "Division 40 plant and equipment depreciation (carpets, blinds, appliances)",
          "Loan establishment costs deducted over five years",
          "Prepaid interest in certain circumstances",
        ],
      },
      {
        heading: "Who it suits — and who it doesn't",
        body:
          "Negative gearing magnifies both upside and downside. It works for some investors and is risky for others:",
        bullets: [
          "Suited: high marginal-rate investors with strong cash flow, long-term horizon and tolerance for interest-rate risk",
          "Suited: investors holding multiple properties with diversified locations and rental profiles",
          "Less suited: investors close to retirement (loss carry-forward is harder to utilise once wages stop)",
          "Risky: investors stretching cash flow with little buffer — a vacant period or rate rise can hurt",
        ],
      },
      {
        heading: "Capital Gains Tax (CGT) considerations",
        body:
          "Capital growth is the prize — but it comes with CGT on sale. Key planning levers:",
        bullets: [
          "Hold longer than 12 months as an individual to access the 50% CGT discount",
          "Time the sale year to coincide with lower-income years where possible",
          "Carry forward any unused losses against future capital gains",
          "Watch the principal-place-of-residence main residence rules when converting from PPR to investment property",
        ],
      },
      {
        heading: "How ABS Solutions helps",
        body:
          "We model your investment property cash flow, optimise depreciation, manage the annual tax return and project the long-term outcome — so you understand exactly what your strategy will deliver:",
        bullets: [
          "Cash-flow and tax modelling before purchase",
          "ATO-compliant depreciation schedules to maximise deductions",
          "Annual investment property tax return and rental schedule",
          "CGT planning and exit-strategy modelling",
          "Bilingual EN / ZH advice and structuring",
        ],
      },
    ],
  },

  "home-office-tax": {
    title: "Working From Home — Tax Deductions Explained | ABS Solutions",
    metaDescription:
      "Claim your home-office deductions correctly — ATO fixed-rate vs actual cost method, eligible expenses, work-from-home records and the 2025–26 changes explained.",
    h1: "Working from home — how to claim tax deductions.",
    intro:
      "Working from home? You may claim a portion of expenses to reduce your tax — but only when you follow the ATO rules and keep good records.",
    sections: [
      {
        heading: "Two methods to choose from",
        list: [
          { heading: "Fixed-rate (per hour)", body: "Apply the ATO's published rate against your hours worked from home." },
          { heading: "Actual cost method", body: "Claim a calculated portion of running expenses based on real usage." },
        ],
      },
      {
        heading: "Dedicated work area",
        body:
          "A dedicated, separately identifiable area (e.g. a study) allows a proportional claim against electricity, heating and cooling, cleaning, furniture depreciation and equipment repairs. The ATO may ask for photos, floor plans and written explanation.",
      },
      {
        heading: "Common claimable items",
        bullets: [
          "Lighting, heating and cooling",
          "Cleaning of the work area",
          "Depreciation of office furniture and equipment",
          "Work portion of phone and internet",
          "Stationery, printer ink and work software / subscriptions",
        ],
      },
      {
        heading: "What employees usually can't claim",
        bullets: [
          "Rent or mortgage interest",
          "Council rates and home insurance",
          "Coffee, snacks and personal items",
          "Home decoration and unrelated renovations",
        ],
      },
    ],
  },

  "business-travel-tax": {
    title: "Business Travel Expenses — Tax Deductions | ABS Solutions",
    metaDescription:
      "Claim business travel deductions correctly — flights, accommodation, meals, vehicle and overseas trips. Travel diaries, allowances and ATO substantiation rules explained.",
    h1: "Business travel expenses — how to claim.",
    intro:
      "Travel for work? Many expenses are deductible — but only when the trip is genuinely business-related and properly documented.",
    sections: [
      {
        heading: "What you can usually claim",
        bullets: [
          "Flights, trains, taxis, rideshare and rental cars",
          "Accommodation while away on business",
          "Reasonable meal costs while travelling overnight",
          "Conference and event registration fees",
        ],
      },
      {
        heading: "What you cannot claim",
        bullets: [
          "Private leisure costs on a mixed-purpose trip",
          "Companion / partner travel costs",
          "Routine commuting between home and your regular work location",
        ],
      },
      {
        heading: "Records you must keep",
        bullets: [
          "Travel diary for trips longer than 6 nights",
          "Tax invoices for accommodation, transport and meals",
          "Evidence of work-related purpose",
        ],
      },
    ],
  },

  // ============================================================
  // Blog / Insights long-form posts (Feb 2026)
  // ============================================================

  "sole-trader-vs-company": {
    title: "Sole Trader vs Pty Ltd — Which Business Structure is Right for You? | ABS Solutions",
    metaDescription:
      "Sole trader vs Pty Ltd company in Australia — compare tax rates, liability, set-up cost, compliance and which structure suits your business stage. Expert guide.",
    h1: "Sole trader vs Pty Ltd: choosing the right business structure in Australia.",
    intro:
      "One of the first big decisions for any Australian business owner is whether to operate as a sole trader or set up a Pty Ltd company. The right structure affects your tax, your personal liability, what it costs to run, and how investable your business looks. Here's how to weigh up the trade-offs.",
    sections: [
      {
        heading: "The two structures at a glance",
        body:
          "A sole trader is the simplest structure — you trade under your own Tax File Number (TFN) with an Australian Business Number (ABN), keep all profits and bear all losses personally. A Pty Ltd company is a separate legal entity registered with ASIC, taxed at the company tax rate (25% for base rate entities, 30% otherwise) and shielding shareholders behind limited liability.",
        bullets: [
          "Sole trader — taxed at your marginal rate (up to 45% + Medicare), simple to set up, unlimited personal liability",
          "Pty Ltd company — flat 25%/30% tax rate, ASIC compliance, separate legal entity, limited liability for shareholders",
          "Trusts and partnerships are alternatives but sit outside the scope of this article",
        ],
      },
      {
        heading: "When a sole trader makes sense",
        body:
          "Sole-trader structures suit early-stage solo operators with modest profits, low risk exposure and minimal asset base. The cost to set up is essentially zero (you just register an ABN), reporting is simple (one tax return) and you keep 100% of after-tax profits. The trade-off is personal liability — every business debt is your debt — and tax bracket creep once profits exceed roughly $100k.",
      },
      {
        heading: "Why most growing businesses move to Pty Ltd",
        bullets: [
          "Tax: company tax is capped at 25% (base rate entities) vs personal marginal rates that can hit 47%",
          "Asset protection: shareholders are generally only liable for unpaid share capital, not company debts",
          "Credibility: suppliers, banks and major customers often prefer dealing with companies",
          "Income flexibility: directors can draw salary, dividends or both — opening planning opportunities",
          "Capital raising: companies can issue shares to investors; sole traders cannot",
        ],
      },
      {
        heading: "Real-world tax comparison",
        list: [
          { heading: "$80k profit", body: "Sole trader pays ~$16,467 (marginal). Pty Ltd pays $20,000 (25%) but retained earnings can be reinvested at 25% — a sole trader can't do that." },
          { heading: "$150k profit", body: "Sole trader pays ~$40,067. Pty Ltd pays $37,500. The company already starts to win once profits exceed roughly $135k." },
          { heading: "$300k profit", body: "Sole trader pays ~$103,667 (47% top bracket). Pty Ltd pays $75,000. The company saves nearly $29k per year — funds you can reinvest or distribute as dividends with franking credits." },
        ],
      },
      {
        heading: "The hidden costs of running a company",
        bullets: [
          "ASIC annual review fee ($321 in 2025–26 for proprietary companies)",
          "Annual company tax return, financial statements and bookkeeping",
          "Director ID registration and ongoing director duties under the Corporations Act",
          "Workers' compensation if you employ staff — different rules than as a sole trader",
          "More complex transactions involving Division 7A if directors borrow from the company",
        ],
      },
      {
        heading: "How to decide: ABS Solutions' 5-question checklist",
        list: [
          { heading: "1. What's your expected profit?", body: "Below ~$80k → sole trader usually wins. Above ~$135k → company starts to win." },
          { heading: "2. How risky is your industry?", body: "Trades, construction, hospitality and consulting with deliverables = limited-liability structures protect personal assets." },
          { heading: "3. Are you reinvesting or living off the income?", body: "Reinvesting = company. Drawing it all out = sole trader can be simpler." },
          { heading: "4. Will you take on partners or investors?", body: "If yes — company every time. Issuing shares is impossible as a sole trader." },
          { heading: "5. What's your long-term exit?", body: "Selling a company structure is cleaner and often more tax-efficient than selling a sole-trader business." },
        ],
      },
    ],
  },

  "division-7a-director-loans": {
    title: "Division 7A Explained — Can a Director Withdraw Cash From the Company? | ABS Solutions",
    metaDescription:
      "Division 7A in plain English — when directors can withdraw cash from a Pty Ltd company, how loans are treated by the ATO, complying loan agreements and tax traps to avoid.",
    h1: "Division 7A: can a director just take money out of the company account?",
    intro:
      "A common misconception is that the cash sitting in your company's bank account belongs to you personally. It doesn't. The Australian Taxation Office uses Division 7A of the Income Tax Assessment Act 1936 to stop directors and shareholders dressing up dividends as loans. Get it wrong, and the entire withdrawal becomes a deemed unfranked dividend — taxed at the director's marginal rate with no franking credits to soften the blow.",
    sections: [
      {
        heading: "What is Division 7A and why does it exist?",
        body:
          "Division 7A applies to private companies and treats certain payments, loans and debt forgiveness to shareholders (or their associates) as deemed dividends. The point is to stop business owners building up retained earnings in a company taxed at 25%, then quietly withdrawing the cash without paying personal tax on it. If the amount you take isn't formal salary, a properly franked dividend or a complying Div 7A loan, the ATO will treat it as a deemed dividend.",
        bullets: [
          "Applies only to private (Pty Ltd) companies",
          "Captures payments, loans and debt forgiveness to shareholders or associates",
          "Reviewed every income year — a single transaction can trigger it",
          "Penalty: the full amount taxed as unfranked dividend income to the director",
        ],
      },
      {
        heading: "Why directors fall into the Division 7A trap",
        body:
          "Most cases aren't deliberate tax evasion — they're paperwork failures. A director takes $30,000 from the company to renovate a kitchen, intends to repay it, doesn't sign a written loan agreement, doesn't make the minimum yearly repayment, and the ATO treats the whole $30,000 as a deemed dividend in that year. Marginal tax at 47% means $14,100 in tax that was easily avoidable.",
      },
      {
        heading: "The three ways to legally take money out",
        list: [
          { heading: "1. Salary or director's fees", body: "Run through payroll, PAYG withheld, super paid. Deductible to the company, fully taxed in the director's hands. The cleanest method." },
          { heading: "2. Franked dividends", body: "Paid out of retained earnings after company tax. Director receives a franking credit equal to the company tax already paid — preventing double taxation." },
          { heading: "3. A complying Division 7A loan", body: "Written agreement, ATO benchmark interest rate (8.77% for 2025–26), minimum yearly repayments over 7 years (unsecured) or 25 years (secured against real property)." },
        ],
      },
      {
        heading: "What a complying Division 7A loan must include",
        bullets: [
          "A written loan agreement signed before the company's tax return is lodged",
          "An interest rate at or above the ATO benchmark rate (set annually by the Commissioner)",
          "A fixed maximum loan term — 7 years unsecured or 25 years if secured over real property",
          "Minimum yearly repayments calculated using the ATO formula",
          "Repayments not funded by further loans from the same company",
        ],
      },
      {
        heading: "Common Division 7A mistakes ABS Solutions sees every year",
        bullets: [
          "Personal credit card or Uber Eats paid with the company card and never repaid",
          "Director's home renovations or school fees paid from company funds",
          "Loans to a director's spouse, parents or family trust ('associates' — Div 7A still applies)",
          "Missing the minimum yearly repayment by even one dollar — triggers a deemed dividend on the shortfall",
          "Forgiveness of an existing director loan — counts as a deemed dividend equal to the forgiven amount",
        ],
      },
      {
        heading: "How to stay on the right side of Division 7A",
        list: [
          { heading: "Keep personal and business cash separate", body: "Pay yourself a regular salary or director's fee — don't dip into the company bank for living expenses." },
          { heading: "Sign loan agreements before year-end", body: "If a withdrawal happens mid-year, document it as a Division 7A loan before 30 June (or the company's lodgement date)." },
          { heading: "Track the minimum yearly repayment", body: "Diarise it. Even a $5 shortfall triggers a deemed dividend on the unpaid amount." },
          { heading: "Review every year with your accountant", body: "Division 7A interacts with FBT, PSI and franking rules — a small mistake can cascade into a large tax bill." },
        ],
      },
    ],
  },

  "cash-flow-management": {
    title: "Cash Flow Management Guide for Australian Small Businesses | ABS Solutions",
    metaDescription:
      "Practical cash-flow management for Australian small businesses — forecasting, debtor control, payment terms, GST timing and the metrics that keep you solvent.",
    h1: "A practical cash-flow guide for Australian small businesses.",
    intro:
      "Profit is theory; cash is reality. Australian Securities and Investments Commission data shows insolvent trading and poor strategic management remain the leading causes of small-business failure — and almost all of them trace back to a cash-flow blind spot. Here's how to manage cash like the financially confident operators we work with at ABS Solutions.",
    sections: [
      {
        heading: "Profit ≠ cash — and why that matters",
        body:
          "Your profit-and-loss can show a healthy $200k profit while you're calling the bank to delay rent. The reason: P&L records revenue when you invoice, not when you're paid; it ignores GST timing, BAS instalments, equipment purchases and loan principal repayments. Cash-flow management is about understanding the timing of every dollar in and out — not just the totals.",
        bullets: [
          "Track operating, investing and financing cash flow separately",
          "Match invoice payment terms to your supplier payment terms",
          "Plan for BAS, super, PAYG and tax instalments quarterly",
          "Hold a minimum 8-week operating-cost cash reserve",
        ],
      },
      {
        heading: "The 13-week rolling forecast — your single most useful tool",
        body:
          "Forget annual budgets — they're outdated by week 3. A 13-week rolling cash-flow forecast (updated weekly) catches problems early, lets you negotiate with suppliers from a position of strength, and gives lenders the confidence to extend overdraft limits. We build these in Xero or a simple spreadsheet for clients in every industry — hospitality, trades, e-commerce, professional services.",
      },
      {
        heading: "Five levers to pull when cash gets tight",
        list: [
          { heading: "1. Tighten debtor terms", body: "Move from 30-day to 14-day payment. Offer 2% early-pay discounts. Invoice the day the work is delivered, not at end-of-month." },
          { heading: "2. Negotiate supplier terms", body: "Ask suppliers for 30 or 45-day terms instead of COD. Most will agree if you pay reliably." },
          { heading: "3. Manage GST timing", body: "Move from monthly to quarterly BAS if eligible — frees up cash for 30–60 extra days each cycle." },
          { heading: "4. Use the ATO payment plan", body: "If you can't pay BAS or tax in full, the ATO offers interest-bearing plans up to 24 months — usually cheaper than skipping supplier payments." },
          { heading: "5. Defer non-critical CAPEX", body: "Postpone vehicles, fit-outs and equipment until the forecast shows room. Or finance them with a chattel mortgage matching the cash-flow profile." },
        ],
      },
      {
        heading: "Cash-flow KPIs every small business should track monthly",
        bullets: [
          "Debtor Days — average days customers take to pay (target: under 35 days)",
          "Creditor Days — average days you take to pay suppliers (target: 30–45 days)",
          "Cash Conversion Cycle — debtor days + stock days − creditor days (lower is better)",
          "Operating Cash Flow Margin — operating cash ÷ revenue (target: above 10%)",
          "Cash Reserve Months — cash ÷ monthly fixed costs (target: 2+ months)",
        ],
      },
      {
        heading: "Common cash-flow mistakes ABS Solutions sees",
        bullets: [
          "Treating BAS-collected GST as 'income' — it's the ATO's money sitting in your account",
          "Topping up personal accounts from company cash mid-month without documenting Division 7A",
          "Letting a single customer reach 25%+ of receivables without a credit limit",
          "No separate tax-and-super savings account — quarterly liabilities catch owners by surprise",
          "Buying inventory on a quarterly bulk discount and forgetting it's tying up cash for 90 days",
        ],
      },
    ],
  },

  "single-touch-payroll-stp": {
    title: "Single Touch Payroll (STP) Explained — How It Works in Australia | ABS Solutions",
    metaDescription:
      "Single Touch Payroll (STP) in plain English — what it reports to the ATO, who needs to comply, STP Phase 2, common errors and how ABS Solutions helps you stay compliant.",
    h1: "Single Touch Payroll (STP): what it is and how it works.",
    intro:
      "If you employ anyone in Australia — even one casual — you're required to use Single Touch Payroll (STP) to report wages, PAYG withholding and superannuation to the ATO every payday. Here's a no-jargon explanation of what STP does, what STP Phase 2 changed, and the mistakes that trigger ATO follow-ups.",
    sections: [
      {
        heading: "What is Single Touch Payroll?",
        body:
          "STP is a reporting framework that requires employers to send payroll information to the ATO each time staff are paid — not once a year via a payment summary. STP pulls gross wages, tax withheld and super liabilities directly from your payroll software (Xero, MYOB, QuickBooks, KeyPay, etc.) and sends a 'pay event' to the ATO via a secure API.",
        bullets: [
          "Mandatory for all employers since 1 July 2019",
          "Replaces annual PAYG payment summaries to employees",
          "Reports gross wages, allowances, deductions, PAYG withholding and super",
          "Employees view year-to-date pay info via myGov, not paper summaries",
        ],
      },
      {
        heading: "Why the ATO introduced STP",
        body:
          "Before STP, the ATO had visibility of wages only once a year — often too late to catch unpaid super, under-withholding or sham contracting. STP gives the ATO real-time data, allowing them to nudge employers who fall behind on super, and to pre-fill employee tax returns with reliable income data on the first day of July each year.",
      },
      {
        heading: "STP Phase 2 — what changed in 2022",
        bullets: [
          "Disaggregated gross income — separately report bonuses, commissions, allowances, overtime, leave",
          "Employment type — full-time, part-time, casual, labour hire reported explicitly",
          "Country code for working-holiday-makers",
          "Cessation reason when employees leave (resignation, dismissal, redundancy, etc.)",
          "Lump-sum payment types broken down (E, W, A, B, D and back-pay)",
        ],
      },
      {
        heading: "Common STP errors ABS Solutions fixes for clients",
        list: [
          { heading: "Mis-classified employees", body: "Casuals reported as part-time, or contractors reported as employees — distorts super and PAYG calculations." },
          { heading: "Missing super stapling check", body: "Since November 2021, employers must request the employee's 'stapled' super fund from the ATO before defaulting them to the employer's fund." },
          { heading: "Pay categories not mapped to STP Phase 2", body: "An allowance reported as 'gross' instead of 'cents per kilometre' — triggers ATO query letters." },
          { heading: "Missed end-of-year finalisation", body: "STP year-end finalisation declaration must be lodged by 14 July — employees can't lodge their tax return cleanly without it." },
        ],
      },
      {
        heading: "How ABS Solutions sets up STP correctly",
        bullets: [
          "Configure or review Xero/MYOB/QuickBooks for STP Phase 2 compliance",
          "Map every pay category to the correct ATO income type",
          "Set up SuperStream-compliant super payments via clearinghouse",
          "Lodge end-of-year STP finalisation declarations before 14 July",
          "Liaise with the ATO on any STP error notifications on your behalf",
        ],
      },
    ],
  },

  "hospitality-tax-deductions": {
    title: "Tax Deductions for Australian Hospitality Workers — Complete Guide | ABS Solutions",
    metaDescription:
      "Complete guide to tax deductions for chefs, baristas, waiters, bartenders and hospitality workers in Australia — uniforms, training, tools, knives, travel and ATO rules.",
    h1: "The complete guide to tax deductions for Australian hospitality workers.",
    intro:
      "Hospitality is one of the most tax-active industries in Australia — chefs, baristas, waiters, bartenders, kitchen hands and hotel staff all qualify for a wide range of work-related deductions that can return hundreds (sometimes thousands) of dollars at tax time. But the ATO also targets this industry for over-claims. Here's exactly what you can claim, what you can't, and the receipts you need to keep.",
    sections: [
      {
        heading: "The golden rules — the ATO's 3-step deduction test",
        body:
          "Before claiming anything, every expense must satisfy three tests: (1) you spent the money yourself and were not reimbursed; (2) the expense directly relates to earning your income; and (3) you have records to prove it. If you fail any one of these, the deduction is denied — and the ATO can reach back 4 years to claw it back with interest.",
        bullets: [
          "Pay personally and not reimbursed by the employer",
          "Direct connection to earning hospitality income",
          "Written records — receipts, logbooks, diary entries",
          "Apportion any private use (e.g. 80% work / 20% private)",
        ],
      },
      {
        heading: "What hospitality workers can claim",
        body:
          "The deductions below are the most commonly accepted by the ATO for hospitality roles. Always keep tax invoices or receipts where the value exceeds $10 per item or $200 total in a year — without records the ATO will disallow the claim on audit.",
      },
      {
        heading: "Equipment, tools and uniform",
        list: [
          { heading: "Chef's knives and kitchen tools", body: "Chef knives, mandolins, peelers, thermometers — claim outright if each item is under $300, depreciate over the effective life if above." },
          { heading: "Uniform with employer logo", body: "Branded chef whites, branded aprons, branded polo shirts and pants — fully deductible. Cleaning is also deductible." },
          { heading: "Non-slip work shoes", body: "Compulsory or protective footwear (steel-cap, non-slip) — deductible. Regular work shoes are not." },
          { heading: "Sommelier and barista certifications", body: "RSA, RSG, barista courses, sommelier exams — deductible if the qualification relates to your current role." },
          { heading: "Knife sharpening and maintenance", body: "Knife sharpening fees, knife rolls, knife guards — deductible." },
        ],
      },
      {
        heading: "Training, certifications and unions",
        list: [
          { heading: "Mandatory certifications", body: "RSA, RSG, food handler certificates, allergens course renewals — fully deductible." },
          { heading: "Self-education", body: "Certificate III/IV in Commercial Cookery, hospitality management diplomas — deductible if directly related to your current job, not a future role." },
          { heading: "Industry magazines and online subscriptions", body: "Hospitality Magazine, Good Food Guide subscriptions — apportion to work-related use." },
          { heading: "Union fees and memberships", body: "United Workers Union, AHIA fees — fully deductible." },
        ],
      },
      {
        heading: "Travel, meals and other expenses",
        list: [
          { heading: "Between-job travel", body: "If you work two hospitality jobs in one day, the cost of travel between them is deductible (not home → work travel)." },
          { heading: "Overnight travel", body: "If sent interstate for a function or banquet, accommodation and meals are deductible — keep a travel diary if away more than 6 nights." },
          { heading: "Mobile phone use", body: "Apportion phone bill for work-related calls (shift changes, supplier calls, customer bookings)." },
          { heading: "Tax agent fees", body: "100% deductible in the year paid — including ABS Solutions' fee for preparing this return." },
        ],
      },
      {
        heading: "What hospitality workers CANNOT claim",
        bullets: [
          "Regular black work shoes or generic clothing without an employer logo",
          "Haircuts, makeup or personal grooming — even if rosters require it",
          "Meals consumed during a normal shift (whether eaten or not)",
          "Travel from home to your regular workplace",
          "Drinks consumed during 'tasting' nights paid by you personally",
          "Childcare while you're at work",
        ],
      },
    ],
  },

  "tpar-taxable-payments": {
    title: "What is the Taxable Payments Annual Report (TPAR)? | ABS Solutions",
    metaDescription:
      "TPAR explained — which businesses must lodge a Taxable Payments Annual Report, what contractors to include, due dates, penalties and how ABS Solutions prepares yours.",
    h1: "What is the Taxable Payments Annual Report (TPAR)?",
    intro:
      "If you pay contractors in certain industries — building and construction, cleaning, courier or road-freight, IT, security or investigation, or government department work — the ATO requires you to lodge a Taxable Payments Annual Report (TPAR) every year. It's a separate report from your BAS or company tax return, due by 28 August, and missing it triggers automatic penalties of up to $313 per 28 days late.",
    sections: [
      {
        heading: "Why does TPAR exist?",
        body:
          "TPAR exists to combat cash-in-hand contracting and under-reported contractor income. The ATO uses TPAR data to cross-check whether contractors reported the income their clients said they paid them. Industries with historically high cash-economy activity were chosen for mandatory reporting, with new industries added each year as the program expands.",
        bullets: [
          "Building & construction (since 2012)",
          "Cleaning services (since 2018)",
          "Courier services (since 2018)",
          "Road freight services (since 2019)",
          "IT services (since 2019)",
          "Security, investigation or surveillance services (since 2019)",
        ],
      },
      {
        heading: "Who has to lodge a TPAR?",
        body:
          "If 10% or more of your business income comes from a TPAR-reportable industry AND you have paid contractors during that financial year, you must lodge. Government entities lodge TPAR for ALL contractor payments regardless of the 10% rule. Sole traders, partnerships, trusts and companies are all in scope.",
      },
      {
        heading: "What information goes into a TPAR?",
        bullets: [
          "Contractor's ABN, name and business address",
          "Total amount paid to that contractor during the financial year (GST inclusive)",
          "Total GST included in those payments",
          "Total payments made to each individual contractor — not lumped",
          "Excluded: payments to employees (covered by STP), payments for materials only, payments under $75 GST-inclusive",
        ],
      },
      {
        heading: "Due dates and penalties",
        list: [
          { heading: "Annual due date", body: "28 August following the end of each financial year (e.g. TPAR for FY2025–26 is due 28 August 2026)." },
          { heading: "Failure to lodge on time penalty", body: "From $313 (small entity) up to $1,565 (large entity) per 28 days late, capped at 5 increments." },
          { heading: "Failure to lodge a 'nil' report", body: "If you operate in a TPAR industry but paid no contractors, you must still lodge a Non-Lodgment Advice (NLA) — silence is treated as a late lodgement." },
          { heading: "Inaccurate TPAR", body: "ATO can disallow contractor deductions on your company tax return if the contractor's ABN is invalid or missing." },
        ],
      },
      {
        heading: "How ABS Solutions prepares your TPAR",
        bullets: [
          "Identify all contractors paid during the year via Xero/MYOB/QuickBooks payable reports",
          "Validate every contractor's ABN against the Australian Business Register",
          "Flag any contractor missing an ABN — apply 47% no-ABN withholding for FY",
          "Reconcile contractor totals to your general ledger and BAS lodgements",
          "Lodge TPAR electronically via the ATO Online Services for Agents",
          "Issue contractors with a Recipient-Created Tax Invoice (RCTI) summary on request",
        ],
      },
    ],
  },

  "car-personal-or-company": {
    title: "Buying a Car in Australia — Personal or Company Name? | ABS Solutions",
    metaDescription:
      "Buying a car under personal vs company name in Australia — compare tax deductions, FBT, GST, depreciation and which option saves you more. Real-world examples included.",
    h1: "Buying a car in Australia — personal or company name?",
    intro:
      "It's one of the most common questions Australian business owners ask us: should I buy this car personally, or put it in the company name? The answer depends on usage patterns, your business structure, and whether you're prepared to pay Fringe Benefits Tax (FBT). Here's the honest comparison — with real numbers — so you can decide.",
    sections: [
      {
        heading: "The core trade-off",
        body:
          "Buying personally means simpler tax — you only claim work-related kilometres (cents-per-km method) or a logbook proportion of running costs. Buying through the company unlocks GST credits, immediate write-offs and full deductibility of all running costs — but exposes you to Fringe Benefits Tax on any personal use. Whether the FBT cost outweighs the tax benefits depends on how you use the car.",
        bullets: [
          "Personal: claim work-related use only; no GST credit; no FBT risk",
          "Company: claim 100% running costs; GST credit on purchase (capped at car limit); pays FBT on personal use",
          "Hybrid: salary-package via novated lease, balancing deduction and FBT exemption rules",
        ],
      },
      {
        heading: "Buying personally — the simple option",
        body:
          "If your work-related use is below 5,000 km per year and the car is mostly for private use, buying personally is almost always the best answer. You claim 88¢ per work-related kilometre (FY2025–26 rate) up to 5,000 km, without needing a logbook. Above 5,000 km, you switch to the logbook method and claim the business-use proportion of fuel, rego, insurance, servicing and depreciation.",
      },
      {
        heading: "Buying through the company — when it pays off",
        list: [
          { heading: "GST credit", body: "Companies claim back the GST on the purchase price, up to the luxury car tax limit ($69,674 in FY2025–26)." },
          { heading: "Instant asset write-off", body: "Cars under $20,000 are immediately deductible for small business entities — until 30 June 2025 (program subject to extension each Budget)." },
          { heading: "Depreciation cap", body: "Cars above the LCT limit ($91,387 in FY2025–26 for fuel-efficient vehicles) cap depreciation at the limit — luxury portion is not deductible." },
          { heading: "100% running costs", body: "Fuel, rego, insurance, servicing, tyres, parking — fully deductible (with FBT adjustment for any private use)." },
          { heading: "Interest on car loan", body: "Fully deductible if the car is on the company balance sheet and used for business." },
        ],
      },
      {
        heading: "Fringe Benefits Tax — the elephant in the room",
        body:
          "If your company-owned car is available for the personal use of an employee or director, FBT applies. FBT is calculated at the top marginal rate (47%) and can wipe out the tax benefits of company ownership entirely if the personal-use percentage is high.",
        bullets: [
          "Statutory method — 20% × cost × days available × (1 − business use %)",
          "Operating cost method — running costs × (1 − business use %) — better for high business-use",
          "FBT-exempt electric vehicles — zero FBT until 1 April 2027 (subject to law change)",
          "Pool vehicle exemption — if the car is genuinely shared and not allocated to one person",
          "Work-related vehicles — exempt if utes/vans under 1-tonne with only minor private use",
        ],
      },
      {
        heading: "Worked example: $60,000 SUV, 70% business use",
        list: [
          { heading: "Personal — logbook method", body: "Total running costs $14,000 × 70% = $9,800 deduction. Tax saving at 47% marginal = $4,606. No FBT." },
          { heading: "Company — statutory method", body: "Tax deduction on full $14,000 + $9,818 depreciation = $23,818 × 25% company tax = $5,955 saving. But FBT on 30% private use = $3,628. Net saving = $2,327." },
          { heading: "Company — operating cost method", body: "Same $23,818 deduction, but FBT calculated on actual 30% private use of running costs = $1,974. Net saving = $3,981." },
          { heading: "Verdict", body: "For mostly business use (70%+), company ownership with operating-cost FBT method usually wins. For mostly private use (under 50%), personal ownership wins comfortably." },
        ],
      },
      {
        heading: "Special case: electric vehicles",
        body:
          "Since 1 July 2022, eligible zero or low-emission vehicles below the LCT threshold for fuel-efficient vehicles ($91,387 in FY2025–26) are FBT-exempt — meaning your company can provide an EV for full personal use without any FBT. Combined with the GST credit and accelerated depreciation, this is one of the most tax-effective car purchase strategies currently available — but the FBT exemption is legislated to end on 1 April 2027 unless extended.",
      },
    ],
  },

  "payday-super": {
    title: "Payday Super Australia 2026: What Employers Must Do Now | ABS Solutions",
    metaDescription:
      "Payday Super started 1 July 2026. Learn the 7-business-day rule, SGC penalties, the STP changes, cash flow impact and how to stay compliant — from a Canterbury accounting firm that helps small business every day.",
    h1: "Payday Super is here: what Australian employers need to do now.",
    intro:
      "If you run payroll for even one employee, you've probably heard the term \u201CPayday Super\u201D thrown around a lot over the last year. As of 1 July 2026, it's no longer a future change — it's the law, and if your business hasn't adjusted, this is the moment to catch up. We're a small accounting firm in Canterbury, Victoria, and over the past few months almost every business client we work with has asked some version of the same question: \u201CDo I actually need to pay super every payday, or just make sure it's processed every payday?\u201D The answer trips a lot of people up — let's go through it properly.",
    sections: [
      {
        heading: "What is Payday Super, in plain English?",
        body:
          "Payday Super changes when employers have to pay superannuation guarantee (SG) — not how much. The SG rate is still 12%, and you still don't pay super on the same group of employees you didn't before. The change is timing. Under the old rules, you had until 28 days after the end of each quarter to pay super. From 1 July 2026, super has to be paid in line with your normal pay cycle, and it has to actually land in the employee's fund within 7 business days of payday — not just be initiated or sitting in a clearing house queue. That last part is the detail most business owners miss.",
        bullets: [
          "SG rate stays at 12% — the amount hasn't changed, the timing has",
          "Quarterly payments are gone; super now moves with every pay run",
          "Super must physically arrive in the fund within 7 business days of payday",
          "\u201CProcessed\u201D is not the same as \u201Creceived\u201D — the obligation is on the employer",
        ],
      },
      {
        heading: "The 7-business-day rule: what actually counts",
        body:
          "This is the part worth getting exactly right, because it's the part the ATO is most focused on. It's not enough to hit \u201Cpay\u201D in your payroll software within 7 business days. The rule is that the super fund must receive the contribution and have enough information to allocate it to the employee's account within that window. If your payment goes through a slow intermediary, or the employee's fund details are wrong or incomplete, the clock doesn't stop for you — it's still your obligation to get it there on time. A few exceptions get a longer runway: for new employees, employers get 20 business days after a new starter's first payday to sort out their choice of fund and get the first contribution through. Outside of those situations, 7 business days is the standard, and it applies to every pay run — weekly, fortnightly or monthly.",
      },
      {
        heading: "What changed with Single Touch Payroll (STP)",
        body:
          "Payday Super isn't just a payment timing change — it changed what you report too. From 1 July 2026, each STP report needs to include, for every eligible employee, the fields below. Qualifying Earnings is what determines the minimum SG you owe for that payday. It's worth knowing that once an employee's YTD QE hits the annual Maximum Contribution Base ($270,830 for 2026–27), you generally don't need to keep paying minimum SG on further QE for that employee for the rest of the financial year — but Super Liability can still include extra amounts owed under an award or enterprise agreement, so don't assume the two figures are interchangeable.",
        bullets: [
          "Year-to-date Qualifying Earnings (QE) — a new measure that has effectively replaced Ordinary Time Earnings (OTE) as the field used for Payday Super reporting",
          "Year-to-date Superannuation Liability",
        ],
      },
      {
        heading: "The Small Business Super Clearing House is gone",
        body:
          "If your business used to rely on the ATO's Small Business Superannuation Clearing House (SBSCH), that service closed on 30 June 2026. If you haven't already moved to a SuperStream-compliant payroll system or a commercial clearing house that can process payments quickly, this is the single most urgent item on your to-do list — without it, hitting the 7-day deadline is very difficult.",
      },
      {
        heading: "What happens if you're late?",
        body:
          "Missing the deadline triggers the Superannuation Guarantee Charge (SGC) — which is more expensive and more administratively painful than just paying the super on time would have been. It typically includes the shortfall itself, interest, and an administration component, and unlike ordinary SG contributions, the SGC generally isn't tax deductible. The ATO has said it's taking a facilitative approach to genuine, minor errors during the first year (1 July 2026 to 30 June 2027) while businesses bed down new processes. But it's also been clear that deliberate or repeated non-compliance — including employers who simply don't attempt to pay SG on payday — will be treated more firmly. Because super fund reporting is now matched against STP data in near real time, late or missing payments are far easier for the ATO to spot than they used to be.",
      },
      {
        heading: "The real challenge for most businesses: cash flow, not compliance",
        body:
          "Almost every business we've spoken to about Payday Super assumed the hard part would be updating software. In practice, the harder adjustment has been cash flow. Under the old quarterly system, many businesses effectively used unpaid super as short-term working capital without really thinking about it that way — the money sat in the business account for up to three months before it had to go out the door. That buffer is gone. Super is now a cost that leaves the business every single pay cycle, at the same rhythm as wages. If your industry has a long gap between doing the work and getting paid for it (recruitment and contracting businesses feel this acutely), that gap now needs to be funded out of cash on hand rather than out of super that hasn't been paid yet. Building a simple rolling cash flow forecast — even a basic one — makes this far less stressful than discovering the shortfall the week super is due.",
      },
      {
        heading: "A checklist to work through now",
        bullets: [
          "Confirm your payroll software actually supports Payday Super and is reporting QE and Super Liability correctly through STP",
          "Move off the SBSCH if you haven't already, and test your new clearing house or fund payment process before you rely on it",
          "Audit employee super fund details — incomplete or incorrect USI/member details are one of the most common reasons contributions get rejected or delayed",
          "Build a short cash flow forecast that treats super as a per-payday cost, not a quarterly one",
          "Brief whoever runs payroll on the exact 7-business-day rule, including the fact that \u201Cprocessed\u201D isn't the same as \u201Creceived\u201D",
        ],
      },
      {
        heading: "Get help getting compliant",
        body:
          "If you're not fully confident your business is set up correctly for Payday Super — or you just want someone to sanity-check your payroll and cash flow position before the ATO does — we're happy to have a look. We work with small to medium businesses across BAS lodgement, payroll compliance and general tax planning, and Payday Super questions have been part of nearly every one of those conversations lately. Get in touch with our team via the contact page and we'll walk through where your business stands.",
      },
      {
        heading: "Related guides you might also find useful",
        list: [
          { heading: "Small Business Tax in Australia", body: "Deductions, instant asset write-off and general compliance for sole traders and companies — visit /small-business-tax." },
          { heading: "BAS Lodgement Support", body: "Keeping your BAS and payroll reporting in sync — visit /bas-lodgement." },
          { heading: "Australian Tax Deadlines", body: "The key dates business owners shouldn't miss — visit /tax-deadlines." },
          { heading: "Bookkeeping & Accounting in Canterbury", body: "Prefer to hand payroll and reconciliation over to us entirely? Visit /canterbury-accounting." },
        ],
      },
      {
        heading: "Disclaimer",
        body:
          "This article is general information only and doesn't take into account your specific circumstances. For advice tailored to your business, get in touch with the ABS Solutions team via our contact page.",
      },
    ],
  },
  "business-structure-guide": {
    title: "Business Structure Guide: Sole Trader, Partnership, Company or Trust? | ABS Solutions",
    metaDescription:
      "Sole trader, partnership, company or trust? ABS Solutions' Melbourne CPAs break down the tax, liability and best-fit scenarios for each — book a free consult.",
    h1: "Business Structure in Australia: Sole Trader, Partnership, Company or Trust?",
    intro:
      "One of the first big decisions any new business owner in Australia has to make is what legal structure to trade under: Sole Trader, Partnership, Company (Pty Ltd), or Trust. It looks like a simple tick-box on an ABN application, but it actually shapes how much tax you pay every year, how exposed your personal assets are, and how easily you can raise capital or sell the business later. Get it wrong, and you could end up paying more tax than necessary — or worse, putting your house and savings on the line when the business hits trouble.",
    youtubeId: "asGKjCKSgTI",
    videoTitle: "Business Structures in Australia Explained",
    videoCaption:
      "A five-minute walkthrough of the four main business structures — sole trader, partnership, company and trust — from the ABS Solutions team.",
    sections: [
      {
        heading: "The four structures at a glance",
        body:
          "In this guide, ABS Solutions (Registered Tax Agents and CPA Australia members) breaks down the four main structures in plain English — the tax treatment, the liability exposure, and which scenarios each one suits best. Choosing the right structure at the start is almost always cheaper than restructuring later, so it's worth understanding what each option actually gives you before you tick a box on the ABN form.",
        bullets: [
          "Sole Trader — simplest to start, but you and the business are legally the same person",
          "Partnership — two or more owners, still with unlimited joint liability",
          "Company (Pty Ltd) — a separate legal entity with limited liability and a flat tax rate of 25–30%",
          "Trust — flexible income distribution and stronger asset protection, but higher setup and admin cost",
        ],
      },
      {
        heading: "1. Sole Trader: simple to start, but unlimited liability",
        body:
          "A sole trader operates under their own name and Tax File Number (TFN) — there's no separate legal entity. This is the default starting point for most freelancers, consultants, delivery drivers, students running a side hustle, and small service businesses. Setup cost is close to zero: register an ABN and you're trading. Reporting is simple because business income flows into your personal tax return, and losses can generally be offset against your other personal income (subject to the non-commercial loss rules). The catch is unlimited liability — business debts are your personal debts, so if the business is sued or can't pay its creditors, your personal assets are exposed. You're also taxed at individual marginal rates: under the 2026–27 brackets, 30% on income between $45,001–$135,000, 37% on $135,001–$190,000, and 45% above $190,000. Best for: early-stage, lower-risk businesses — freelancing, consulting, e-commerce reselling, food delivery, and similar low-liability activities.",
      },
      {
        heading: "2. Partnership: two or more people, shared everything",
        body:
          "A partnership is formed by two or more people (or entities) carrying on a business together — common among professional service firms (accounting, law, medical practices) and family-run trading or hospitality businesses. The partnership itself doesn't pay income tax, but it must still lodge an annual Partnership Tax Return; profits or losses are distributed according to the partnership agreement and included in each partner's individual tax return. Liability is unlimited and joint, meaning if one partner runs up debts or gets into legal trouble, the other partners can be held responsible too. Best for: trusted family members, friends or professional collaborators going into business together in a relatively lower-risk industry. We always recommend a written partnership agreement setting out capital contributions, profit shares, and exit terms before you start — it saves a lot of pain later.",
      },
      {
        heading: "3. Company (Pty Ltd): limited liability and lower, stable tax rates",
        body:
          "A company is one of the most common structures for growing businesses in Australia, governed by the Corporations Act 2001 and regulated by ASIC. Limited liability means the company is a separate legal entity, so in most circumstances shareholders' and directors' personal assets are separate from company debts — though director's personal guarantees or breaches of directors' duties under the Corporations Act can still create personal exposure. Base rate entities (turnover under $50 million and passive income under 80% of total assessable income) pay a company tax rate of 25%; all other companies pay 30% — often significantly lower than the top individual marginal rate of 45%, especially useful if you plan to reinvest profits back into the business. Trade-offs include higher setup and ongoing costs (annual ASIC fees, company return lodgements), more compliance obligations, and franking-credit rules when distributing profits as dividends. Best for: business owners planning long-term growth, wanting to ring-fence personal risk, or considering future investment or sale of the business.",
      },
      {
        heading: "4. Trust: flexible income distribution, stronger asset protection",
        body:
          "A trust isn't a trading entity in itself — it's a legal relationship where a trustee (an individual or company) holds and manages assets or a business for the benefit of beneficiaries. The most common structure among Chinese-Australian family businesses is the Discretionary (Family) Trust. Its pros are flexible income distribution — the trustee can distribute profits to different beneficiaries each year (e.g. family members on lower incomes), legally reducing the family's overall tax burden — and asset protection: a well-structured trust can help separate business assets from personal risk. The cons: higher setup and ongoing cost (a solicitor-drafted Trust Deed is required); any profit not distributed to a beneficiary in a given year is taxed at the top marginal rate of 45% — a trap many business owners overlook; and more complex compliance and documentation, best managed by a professional accountant on an ongoing basis. Best for: business owners with meaningful assets who want tax planning and family wealth protection. Read our dedicated guide: Australian Family Trusts Explained at /family-trust-guide.",
      },
      {
        heading: "Quick comparison",
        list: [
          { heading: "Sole Trader", body: "Unlimited liability, individual marginal rate up to 45%, low setup cost — best when starting out or freelancing." },
          { heading: "Partnership", body: "Unlimited & joint liability, distributed at each partner's individual rate, low–medium setup cost — suits small multi-person ventures." },
          { heading: "Company (Pty Ltd)", body: "Limited liability, 25–30% tax rate, medium–high setup cost — suits growth-stage businesses with expansion plans." },
          { heading: "Trust", body: "Depends on trustee type, distributed profit at beneficiary rate but undistributed profit taxed at 45%, high setup cost — best for tax planning, asset protection and succession." },
        ],
      },
      {
        heading: "How to decide: ask yourself three questions",
        bullets: [
          "How much risk does the business carry? High-contract-value, employing staff, or professional-liability-exposed businesses generally benefit from a company structure",
          "Do you plan to grow, raise capital, or bring in shareholders? If so, a company makes equity design and future financing much simpler",
          "Does your family need income splitting or asset protection? If family members have very different income levels, or you're thinking long-term about wealth transfer, a trust is worth considering",
          "Many owners ultimately use a 'company + trust' hybrid to combine limited liability with tax flexibility",
          "There's no one-size-fits-all answer — the right structure depends on your specific industry, risk tolerance and long-term goals; restructuring later often triggers stamp duty and CGT, so plan ahead",
        ],
      },
      {
        heading: "How ABS Solutions can help",
        body:
          "ABS Solutions (Absolute Business Services) is a family-owned and operated firm with over 11 years serving Australian businesses, led by a team of CPA Australia registered accountants with deep experience across ASIC regulation, tax law, and industries from retail and manufacturing to tech. We offer one-on-one remote accounting support with fully transparent, agreed-upfront pricing and no hidden fees. For business structure decisions, we can recommend the right structure based on your industry, revenue scale and risk profile; handle your full ABN/ACN/GST registration and company or trust setup; support you ongoing with small business tax services and BAS lodgement; and review your existing structure if you've been trading for a while and want to check it still fits your current scale.",
      },
      {
        heading: "Related guides you might also find useful",
        list: [
          { heading: "Small Business Tax in Australia", body: "Deductions, instant asset write-off and general compliance for sole traders and companies — visit /small-business-tax." },
          { heading: "BAS Lodgement Support", body: "Keeping your BAS and payroll reporting in sync — visit /bas-lodgement." },
          { heading: "Australian Family Trusts Explained", body: "Deep dive on family trust setup, tax and distribution — visit /family-trust-guide." },
          { heading: "Company Setup Service", body: "Full ABN/ACN/GST registration and company incorporation — visit /company-setup." },
        ],
      },
      {
        heading: "Book your free consultation",
        body:
          "Not sure which structure fits your business? Get in touch with the ABS Solutions team for advice tailored to your situation. Canterbury Head Office (Melbourne): 205 Canterbury Road, Canterbury VIC 3126 — phone +61 3 9826 1316. Brisbane Office: Level 19, 10 Eagle Street, Brisbane QLD — phone +61 7 3087 3404. Email info@abs-solutions.com.au or use the contact page to book your business structure consultation.",
      },
    ],
  },
  "in-house-vs-outsourced-accounting": {
    title: "In-House vs Outsourced Accounting: What Costs Less in Australia? | ABS Solutions",
    metaDescription:
      "Hiring a full-time accountant or outsourcing? ABS Solutions breaks down the real costs for Australian SMEs so you can make the smarter, more affordable call.",
    h1: "In-House vs Outsourced Accounting: What Australian SME Owners Need to Know Before They Decide",
    intro:
      "At some point, almost every growing business owner faces the same question: should I hire a full-time accountant, or outsource the books to a professional accounting firm? There's no universal right answer — it depends on your business size, cash flow, and where you want to spend your time and energy. In this article, ABS Solutions breaks the decision down across four dimensions: real cost, depth of expertise, flexibility, and risk.",
    youtubeId: "-F_zcY0WZEE",
    videoTitle: "In-House vs Outsourced Accounting: A Cost Comparison for Australian SMEs",
    videoCaption:
      "Watch a quick side-by-side of what a full-time hire actually costs versus outsourcing to a specialist team.",
    sections: [
      {
        heading: "What most owners get wrong about the cost",
        body:
          "Most business owners 'do the maths' on hiring an accountant by looking at the advertised salary — and stop there. That's only part of the picture. The true cost of a full-time hire is usually well above the headline number, and it's a fixed cost that doesn't scale down in quieter months. Outsourcing flips the equation: you get a whole specialist team, but only pay for the work you actually need.",
        bullets: [
          "Base salary is only ~70–75% of the true annual cost of an in-house accountant",
          "12% Super Guarantee, leave loading and public holidays add another 15–20%",
          "Recruitment, software, office space and management time all sit on top of that",
          "Outsourcing is typically fixed or usage-based, so cost tracks the real workload",
        ],
      },
      {
        heading: "1. What does a full-time accountant actually cost?",
        body:
          "A full-time accounting hire typically comes with a base salary — Australian accounting salaries vary considerably by experience, location and industry, from entry-level roles up to roughly $60,000–$90,000+ a year for an experienced accountant — plus 12% Superannuation Guarantee on top of wages; annual leave, sick leave and public holiday pay that typically add another 15–20%; recruitment costs (agency fees, interview time, onboarding and training); office space, equipment and software licensing (Xero, MYOB, etc.); and your own management time — a staff accountant still needs oversight, direction and performance review. Add it all up, and the true annual cost is usually well above the advertised salary figure, and it's a fixed cost that doesn't scale down in quieter months.",
      },
      {
        heading: "2. Outsourced accounting: pay for what you need, with a full team behind you",
        body:
          "Outsourcing to a professional firm (like ABS Solutions) means paying a fixed or usage-based service fee in exchange for the support of an entire team — not just one person's working hours. You get more predictable, transparent cost with fixed packages or itemised service fees, so you know exactly what you're paying — no surprise overtime, no costly handover period when a staff member resigns. You get broader technical depth: it's rare for one in-house accountant to be equally strong across tax planning, SMSFs, audit, BAS lodgement and business structuring; an outsourced firm has a whole team of specialists to draw on, including senior accountants for complex issues like trust distributions or cross-border tax. Support is scalable — more during busy periods, less during quiet ones — without carrying a fixed headcount cost year-round. A professional firm also actively tracks ATO policy changes (like the recent Payday Super and AML/CTF reforms) and proactively flags what you need to do. And you avoid the 'what happens if they leave' risk — an outsourced team runs on structured processes, so handovers are far smoother.",
        bullets: [
          "Predictable, transparent monthly or per-service pricing",
          "A whole specialist team, not one person's Monday-to-Friday",
          "Scales up and down with your busy and quiet seasons",
          "Compliance risk actively managed — new ATO rules flagged before they hurt you",
          "No knowledge gap when someone takes leave or moves on",
        ],
      },
      {
        heading: "3. When does each option make more sense?",
        list: [
          { heading: "Startup or micro-business, lower transaction volume", body: "Outsourced accounting is almost always the better fit." },
          { heading: "High daily transaction volume", body: "In-house bookkeeper + outsourced accountant for tax and compliance oversight." },
          { heading: "SME wanting to control fixed costs", body: "Outsourced accounting keeps the cost variable and tied to activity." },
          { heading: "Large business, very high complexity", body: "In-house team (often combined with external advisors)." },
          { heading: "Specialist SMSF, trust or audit support", body: "Outsourced to a specialist firm gives you depth without a full-time hire." },
        ],
      },
      {
        heading: "4. Local firm or offshore bookkeeping?",
        body:
          "In recent years, some businesses have started outsourcing simple, repetitive bookkeeping tasks offshore (e.g. to India or the Philippines) to cut costs. A few things to keep in mind: offshore teams may have limited familiarity with Australian-specific tax law and the latest ATO policy changes, especially in higher-stakes areas like trust distributions or SMSF compliance; data security and privacy compliance also need to be assessed; and anything requiring you to lodge documents with the ATO or represent your business to the Tax Office must be done by a Registered Tax Agent operating in Australia. This is exactly why many Australian business owners — particularly within the Chinese-speaking community — prefer a locally registered, Mandarin-speaking firm like ABS Solutions: you get the assurance of local professional accreditation without the language or cultural friction.",
      },
      {
        heading: "ABS Solutions: your outsourced accounting team",
        body:
          "ABS Solutions is a family-owned firm with more than 11 years of experience, made up of CPA Australia registered accountants who provide one-on-one, remote accounting support — so you can manage your finances efficiently without stepping into an office. Our outsourced services cover day-to-day bookkeeping and BAS lodgement, small business tax planning and lodgement, tax treatment across company/partnership/trust structures, SMSF setup and annual compliance, and ongoing advisory and business consulting. All pricing is agreed upfront and fully transparent — no hidden fees — so every dollar goes where it should. Also worth bookmarking: our Australian Tax Deadlines guide, so you never miss a key lodgement date and rack up avoidable penalties.",
      },
      {
        heading: "Related guides you might also find useful",
        list: [
          { heading: "BAS Lodgement Support", body: "Keeping BAS and payroll reporting in sync — visit /bas-lodgement." },
          { heading: "Small Business Tax in Australia", body: "Deductions and compliance for sole traders and companies — visit /small-business-tax." },
          { heading: "Australian Tax Deadlines", body: "The key dates business owners shouldn't miss — visit /australian-tax-deadlines." },
          { heading: "Business Structure Guide", body: "Sole trader, partnership, company or trust — visit /business-structure-sole-trader-partnership-company-trust-australia." },
        ],
      },
      {
        heading: "Run the numbers, starting today",
        body:
          "Rather than going back and forth on 'should I hire,' talk to a professional accountant who can map out a real cost comparison based on your actual transaction volume and business complexity. Canterbury Head Office (Melbourne): 205 Canterbury Road, Canterbury VIC 3126 — phone +61 3 9826 1316. Brisbane Office: Level 19, 10 Eagle Street, Brisbane QLD — phone +61 7 3087 3404. Email info@abs-solutions.com.au or use the contact page for a cost comparison tailored to your business.",
      },
    ],
  },
  "aml-ctf-tranche-2": {
    title: "AML/CTF Tranche 2 (2026): What Accountants & Agents Must Know | ABS",
    metaDescription:
      "From 1 July 2026, accountants, lawyers and real estate agents fall under AUSTRAC's AML/CTF regime. ABS Solutions breaks down Tranche 2 obligations and deadlines.",
    h1: "AML/CTF Tranche 2 Reforms (2026): What Accountants, Real Estate Agents and Lawyers Need to Know",
    intro:
      "On 1 July 2026, Australia's anti-money laundering and counter-terrorism financing regulation underwent its biggest expansion in nearly two decades — the Tranche 2 reforms officially took effect. If you're an accountant, lawyer, real estate agent, conveyancer, or a trust and company service provider, your industry has been brought under AUSTRAC's oversight for the first time. For a firm like ABS Solutions — which provides accounting, tax and audit services (including audits for real estate agents, conveyancers, and SMSF trust accounts) — these reforms affect us directly, and they affect a large number of our clients too.",
    youtubeId: "oJRh86okdkE",
    videoTitle: "Australia's AML/CTF Tranche 2 Reforms Explained",
    videoCaption:
      "A plain-English walkthrough of who's captured, what you have to do, and the deadlines that already matter.",
    sections: [
      {
        heading: "Who's in scope and why now",
        body:
          "Australia's Anti-Money Laundering and Counter-Terrorism Financing Act 2006 has, since its inception, only regulated banks, casinos and remittance providers — so-called 'Tranche 1' entities. Lawyers, accountants, real estate agents and similar professions — labelled 'gatekeeper professions' by the Financial Action Task Force (FATF) — remained largely unregulated, making Australia one of the last OECD countries without full AML/CTF coverage of these sectors. On 10 December 2024, the AML/CTF Amendment Act 2024 received royal assent, extending regulatory obligations to entities providing 'designated services' — Tranche 2 entities. The reforms are estimated to bring around 80,000–100,000 new businesses into AUSTRAC's regulatory perimeter — the largest single expansion since the regime was established in 2006.",
        bullets: [
          "Lawyers",
          "Accountants",
          "Real estate agents",
          "Conveyancers",
          "Property developers",
          "Dealers in precious metals and stones",
          "Trust and company service providers",
        ],
      },
      {
        heading: "Key dates you cannot miss",
        list: [
          { heading: "10 December 2024", body: "AML/CTF Amendment Act 2024 receives royal assent." },
          { heading: "31 March 2026", body: "Existing Tranche 1 reporting entities must implement the new rules; AUSTRAC enrolment opens for Tranche 2 entities." },
          { heading: "1 July 2026", body: "Tranche 2 obligations formally commence for newly regulated sectors." },
          { heading: "29 July 2026", body: "Deadline to complete AUSTRAC enrolment if you were already providing designated services as at 1 July. This deadline has now passed — if you haven't enrolled, act immediately, because every unregistered transaction can potentially be treated as a separate contravention." },
        ],
      },
      {
        heading: "What you're actually required to do",
        body:
          "Once you're a captured reporting entity, the core compliance obligations typically include AUSTRAC enrolment (the prerequisite for everything else); a written AML/CTF Program covering risk assessment, internal controls and processes; appointing an AML/CTF Compliance Officer as a 'fit and proper' nominated individual; Customer Due Diligence (CDD) — verifying client identity, understanding the purpose of transactions, and screening for politically exposed persons (PEPs) and sanctions; ongoing monitoring and risk assessment to identify unusual or suspicious transaction patterns; Suspicious Matter Reports (SMRs) reported to AUSTRAC promptly; record keeping for 7 years; and staff training so your team can apply CDD and reporting requirements. A point that's often misunderstood: the reforms regulate the 'designated service' itself, not the job title 'accountant.' Routine tax return preparation, day-to-day bookkeeping and standard advisory work don't, on their own, trigger AML/CTF obligations — but the same accountant is captured the moment they're involved in forming a company or trust, acting as a trustee, managing client funds or assets tied to a designated service, or assisting with a property transaction. Many accounting firms' work spans both categories — which is exactly why mapping out 'which specific services are designated' matters more than a blanket assumption either way.",
        bullets: [
          "AUSTRAC enrolment — the prerequisite for everything else",
          "A written AML/CTF Program covering risk, controls and processes",
          "Named AML/CTF Compliance Officer",
          "Customer Due Diligence (CDD) — identity, purpose, PEPs and sanctions",
          "Ongoing monitoring and Suspicious Matter Reports (SMRs)",
          "7-year record keeping and structured staff training",
        ],
      },
      {
        heading: "How serious are the consequences of non-compliance?",
        body:
          "AUSTRAC's enforcement powers are substantial. Under the AML/CTF Act, the maximum civil penalties a court can order for the most serious contraventions are up to 20,000 penalty units for individuals, and up to 100,000 penalty units for corporations. Using the Commonwealth penalty unit value applicable in 2026 (around $330), that translates to a theoretical ceiling of roughly $6.6 million for individuals and $33 million for corporations — though these are statutory maximums a court can impose, not automatic fines for every breach. AUSTRAC's stated approach is to lead with education and guidance, but escalates firmly against systemic or wilful non-compliance. Separately, 'tipping off' — informing a client that you've lodged, or are considering lodging, a Suspicious Matter Report — is a criminal offence carrying up to 2 years' imprisonment. AUSTRAC's recent enforcement track record against Westpac ($1.3 billion), Crown Resorts ($450 million) and SkyCity Adelaide ($67 million) illustrates the regulator is serious about follow-through. While these are large financial institution cases, AUSTRAC has publicly stated that business size is not a defence — small and mid-sized professional service firms are squarely within scope.",
      },
      {
        heading: "What this means for owners and professionals",
        body:
          "If you're a real estate agent or conveyancer handling property transactions and trust accounts, you're one of the primary focus areas of these reforms. If you're an accountant or tax agent assisting clients with company or trust formation, or business sale/acquisition transactions, the same applies to those parts of your practice. If you're a business owner who works with an accountant, lawyer or real estate agent, the direct compliance burden sits with your service provider — but you may be asked for more detailed identity or transaction information than before, which is a normal part of the new process, not a red flag. For ABS Solutions, which already provides audit services for SMSFs, conveyancers and real estate agents' trust accounts, we've been tracking and implementing these obligations ahead of the curve — which means we're well placed to help clients understand exactly how the new rules affect their business.",
      },
      {
        heading: "What to do now",
        bullets: [
          "Determine whether you're a Tranche 2 entity — if you provide any 'designated service,' you're most likely in scope",
          "If you haven't enrolled with AUSTRAC yet, do it immediately",
          "Build and implement a written AML/CTF Program — don't wait until you're audited to scramble for documentation",
          "Train your team so frontline staff understand CDD and identifying suspicious activity",
          "Set up a proper record-keeping system to meet the 7-year retention requirement",
          "If you're not sure whether your business involves 'designated services,' get advice sooner rather than later",
        ],
      },
      {
        heading: "ABS Solutions: helping you get compliance right",
        body:
          "As a firm that provides both accounting/tax services and audit services (covering SMSFs, conveyancers and real estate agent trust accounts), ABS Solutions understands the practical impact of these reforms on affected industries. We can help you assess whether your business provides an AML/CTF 'designated service'; review your existing customer due diligence processes and identify compliance gaps; prepare documentation for AUSTRAC enrolment and your AML/CTF Program; and fold these obligations into your existing audit and tax compliance workflow. If you're also thinking about business structuring or trust setup, our guide to Australian Family Trusts and our Chinese-speaking Australian accountants overview page may be useful.",
      },
      {
        heading: "Related guides you might also find useful",
        list: [
          { heading: "Australian Family Trusts Explained", body: "Deep dive on family trust setup and tax — visit /family-trust-guide." },
          { heading: "SMSF Set Up and Annual Compliance", body: "SMSF establishment and yearly audit — visit /smsf." },
          { heading: "Chinese-speaking Australian Accountants", body: "Mandarin-fluent accounting and tax across AU — visit /chinese-accountants-australia." },
          { heading: "Services and Pricing", body: "Our full range of accounting, tax and audit services — visit /services-and-price." },
        ],
      },
      {
        heading: "Get in touch to assess your compliance risk",
        body:
          "The reforms have just taken effect — the sooner you act, the easier it is to avoid compliance pressure and potential penalties down the line. Canterbury Head Office (Melbourne): 205 Canterbury Road, Canterbury VIC 3126 — phone +61 3 9826 1316. Brisbane Office: Level 19, 10 Eagle Street, Brisbane QLD — phone +61 7 3087 3404. Email info@abs-solutions.com.au or use the contact page to assess your obligations under the new rules.",
      },
    ],
  },
"box-hill-accountant": {
  title: "Accountant Box Hill | Tax, BAS & SMSF — ABS Solutions",
  metaDescription: "Accountant serving Box Hill and Melbourne's eastern suburbs. Tax returns, bookkeeping, BAS/GST, SMSF and business advisory from a Canterbury-based CPA firm — English & Chinese-speaking team.",
  h1: "Your Accountant in Box Hill, VIC.",
  intro: "Looking for an accountant near Box Hill who actually understands the local business community? ABS Solutions has been based just up the road on Canterbury Road, Canterbury since 2012 — a five-minute drive from Box Hill Central and the Box Hill train/tram interchange. Our CPA Australia-registered accountants work daily with Box Hill's individuals, small businesses and property investors, including much of the area's Chinese-Australian business community, handling everything in English or Mandarin/Cantonese. Whether you're in Box Hill, Box Hill South, Box Hill North, Mont Albert or Surrey Hills, you can meet our team in person at our nearby Canterbury office, or handle everything remotely online — your choice.",
  sections: [
    {
      heading: "Why Box Hill clients choose ABS Solutions",
      bullets: [
        "5 minutes from Box Hill Central and the Box Hill transport interchange",
        "Family-owned practice with 12+ years serving Melbourne's eastern suburbs",
        "CPA Australia members, registered tax agents and SMSF specialists",
        "English, Mandarin and Cantonese spoken — ideal for Box Hill's Chinese-Australian business community",
        "In-person appointments at our Canterbury office, or fully remote service",
      ],
    },
    {
      heading: "Services for Box Hill individuals and businesses",
      list: [
        { heading: "Individual & business tax returns", body: "Accurate, ATO-compliant tax returns for employees, sole traders, companies, trusts and partnerships." },
        { heading: "Bookkeeping & BAS/GST", body: "Xero, MYOB and QuickBooks bookkeeping, quarterly BAS and GST lodgement for Box Hill retailers, restaurants and professional services." },
        { heading: "SMSF setup & administration", body: "Self-managed super fund establishment, annual compliance and audit coordination." },
        { heading: "Company & trust structuring", body: "ABN/ACN/GST registration, family trust setup and business structure advice for Box Hill entrepreneurs." },
        { heading: "Property tax advice", body: "Rental property deductions, depreciation reports and CGT planning — relevant for Box Hill's strong rental and investment property market." },
      ],
    },
    {
      heading: "Working with us",
      list: [
        { heading: "1. Consultation", body: "Meet at our Canterbury office (10 minutes from Box Hill) or book a video call." },
        { heading: "2. Tailored plan", body: "A fixed-price service plan matched to your situation — individual, business or SMSF." },
        { heading: "3. We handle it", body: "Our CPAs and registered tax agents manage lodgements, BAS and compliance end to end." },
        { heading: "4. Ongoing support", body: "Year-round advice as ATO rules, your business, or your investments change." },
      ],
    },
  ],
},
};

export default EN;
